/* SofaMix · pagina de produs E (?view=e).
   Mecanica machetei E (rânduri pliate, desenul la scară, „Configurația ta”, foile, mostrele, bara fixă),
   cu datele luate din APO la rulare: opțiunile, valorile, prețurile, totalul. Nimic din prețuri nu e scris aici.
   Rândurile vin din opțiunile APO ale produsului (orice produs), textele din tabelul din descriere. */
(function () {
  'use strict';
  var root = document.querySelector('.smx-e[data-e-root]');
  if (!root || root.__e) return;
  root.__e = true;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var D = {};
  try { D = JSON.parse($('#e-data').textContent); } catch (err) { D = {}; }
  var html = document.documentElement;
  html.classList.add('e-page');

  /* Scriptul temei (smx-cro-mobile-fixes) derulează la pasul APO următor după fiecare alegere; aici blocul APO e ascuns,
     deci derularea spre el nu are sens: o oprim doar pentru elementele din blocul APO ascuns. */
  var nativeSIV = Element.prototype.scrollIntoView;
  Element.prototype.scrollIntoView = function () {
    if (this.closest && this.closest('.e-apo')) return;
    return nativeSIV.apply(this, arguments);
  };

  /* Straturile (bara, vizualizatorul, 3D, foile) stau direct în <body>, ca position:fixed să nu depindă de secțiune. */
  var layers = $('#e-layers');
  if (layers && layers.parentNode !== document.body) document.body.appendChild(layers);

  var fmt = function (n) { n = Math.round(Number(n) || 0); return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); };
  var lei = function (n) { return fmt(n) + ' lei'; };
  /* Adaosul cu semn: APO poate avea și valori mai ieftine decât baza (preț negativ). */
  var sg = function (n) { n = Number(n) || 0; return n < 0 ? '−' + lei(-n) : '+' + lei(n); };
  /* Scriem în DOM doar ce s-a schimbat (fiecare alegere rulează update() de mai multe ori). */
  function setH(el, h) { if (el && el.__h !== h) { el.innerHTML = h; el.__h = h; } }
  var plus = function (n) { return n ? sg(n) : null; };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var norm = function (t) { return String(t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim(); };
  var cmN = function (n) { return String(n).replace('.', ','); };
  /* „5 culori”, dar „20 de culori” */
  var nde = function (n) { var r = n % 100; return (r >= 1 && r <= 19) ? '' : 'de '; };
  var culori = function (n) { return n + ' ' + nde(n) + 'culori'; };
  var vals = function (o) { return Object.keys(o).map(function (k) { return o[k]; }); };
  var SHORT = D.short || '';
  var WA = 'https://wa.me/' + (D.wa || '40746269559') + '?text=';
  var waLink = function (txt) { return WA + encodeURIComponent(txt); };
  var KIND = D.kind || 'altul', FOT = KIND === 'fotoliu', HAS3D = !!D.cfg;
  var NOARMS = !!D.noArms;  /* canapea fără cotiere (eticheta „fara-cotiere”): fără cotiere în schițe */

  /* ---------- Starea: ce a ales omul (oglinda selecțiilor din APO), pe cheia rândului ---------- */
  var S = { fabric: null, fam: null, started: false };
  /* Până răspunde APO: la colțar, rândurile colțarului (ca pe Lexi); la celelalte, nimic („Se încarcă opțiunile…”). */
  var REQ = KIND === 'coltar' ? ['a', 'b', 'c', 'corner', 'comfort', 'fabric'] : [];
  /* Valorile pe care APO le alege singur la încărcare (is_default): nu contează ca alese de om până nu atinge rândul. */
  var DEF = [], touched = {};
  var SAMPLES = [];
  var SELKEY = 'smx_e_sel:' + location.pathname;
  var ink = '#1E1A17', acc = '#D93006', accInk = '#B52805', soft = '#9C8F84';

  /* ---------- Tabelul din descriere: înălțimi și materiale ---------- */
  var TBL = {
    total: /^inaltime totala/, frame: /^inaltime cadru/, arm: /^inaltime cotiera/, armW: /^latime cotiera/,
    seat: /^inaltime (canapea )?pana la sezut/, cushion: /^grosime (perna|burete) sezut/, cushionLen: /^lungime perna sezut/,
    hasBox: /^lada depozitare/, box: /^inaltime lada( canapea)?$/, boxCorner: /^inaltime lada colt/,
    back: /^grosime spatar/, backH: /^inaltime perna spatar/, legs: /^picioare/, frameMat: /^cadru$/, joint: /^imbinare/,
    seatMat: /^(perne sezut|sezut)/, backMat: /^perne spatar/, weight: /^greutate/, warranty: /^garantie/, bed: /^dimensiune pat/, ext: /^extensibil/
  };
  function num(v) { var m = /(\d+(?:[.,]\d+)?)\s*cm/i.exec(String(v || '')); return m ? parseFloat(m[1].replace(',', '.')) : null; }
  function readTable() {
    var t = { lbl: {} };
    $$('#e-specificatii .e-rte tr').forEach(function (tr) {
      var c = tr.querySelectorAll('td,th'); if (c.length < 2) return;
      var l = norm(String(c[0].textContent || '').replace(/ /g, ' ')).replace(/\s*:$/, '');
      var v = String(c[1].textContent || '').replace(/ /g, ' ').replace(/[ \t]+/g, ' ').trim();
      if (!v || /^(--|—|-)/.test(v)) return;
      for (var k in TBL) { if (TBL[k].test(l)) { if (!(k in t)) { t[k] = v; t.lbl[k] = l; } break; } }
    });
    if (t.cushionLen && /nu are perna|fix/i.test(norm(t.cushionLen))) { t.fixSeat = true; delete t.cushion; }
    if (t.cushion && /nu are perna|fix/i.test(norm(t.cushion))) { t.fixSeat = true; delete t.cushion; }
    var h = /H\s*=\s*([\d.,]+)\s*cm/i.exec(t.legs || '');
    t.legsH = h ? parseFloat(h[1].replace(',', '.')) : num(t.legs);
    return t;
  }
  var T = readTable();
  function profileMatch() {
    if (KIND !== 'coltar' || !D.prof) return false;
    var P = D.prof, pairs = [['total', num(T.total)], ['frame', num(T.frame)], ['arm', num(T.arm)], ['seat', num(T.seat)], ['cushion', num(T.cushion)], ['box', num(T.box)], ['back', num(T.back)], ['legs', T.legsH]];
    return pairs.every(function (p) { var s = num(P[p[0]]); return s !== null && p[1] !== null && s === p[1]; });
  }
  var PROF = profileMatch();

  /* ---------- Adaptorul APO ---------- */
  var ap = null, apoOk = false, apoBox = $('.e-apo');
  var ROWS = [];         // toate rândurile (și cele fără copii active)
  var M = {};            // cheie -> rândul vizibil {key, role, copies, active, vals:[{v,label,ids,price,tip,hidden,avail,img}], byV, other, required}
  var FABO = { std: [], prem: [] };
  var FAB = [], FABN = {}, FABID = {}, FAMS = [], GROUPS = [];
  var BASE = Number(D.base) || 0;
  var lastTot = BASE;
  var LAY = 'none';      // desenul de sus: 'L' (colțar), 'rect' (canapea, fotoliu), 'bed' (pat), 'none'
  var NUM_RX = /^\s*(\d{2,3})\s*(cm)?\s*$/i, BED_RX = /^\s*(\d{2,3})\s*[x×]\s*(\d{2,3})/i;
  var FABRIC_RE = /^material (standard|premium)/i, PSEUDO_RE = /^(aranjare|orientare|dimensiuni\b|lada pentru depozitare)/i;
  var ROLES = [
    ['fabStd', /^material standard/],
    ['fabPrem', /^material premium/],
    ['usb', /priza|usb/],
    ['b', /partea scurta/, NUM_RX],
    ['a', /partea lunga|^lungime\b/, NUM_RX],
    ['c', /^latime canapea|adancime/, NUM_RX],
    ['bed', /^dimensiuni\b/, BED_RX],
    ['corner', /orientare|aranjare/],
    ['comfort', /confort/],
    ['legs', /picioare/],
    ['storage', /\blada\b/]
  ];
  var ORDER = ['a', 'b', 'c', 'bed', 'corner', 'comfort', 'legs', 'storage', 'x'];
  var ICON = { bed: 'e-i-ruler', legs: 'e-i-legs', storage: 'e-i-box', x: 'e-i-plus' };
  var warned = {};

  function apoValueEl(id) { return apoBox ? apoBox.querySelector('[data-value-id="' + id + '"]') : null; }
  function apoOptEl(id) { return apoBox ? apoBox.querySelector('.mw-option[data-option-id="' + id + '"]') : null; }
  function tipOf(id) {
    var el = apoValueEl(id), t = el && el.querySelector('[data-tooltip-text]');
    return t ? String(t.getAttribute('data-tooltip-text') || '').trim() : '';
  }
  function swatchOf(id, size) {
    var el = apoValueEl(id), img = el && el.querySelector('img');
    var src = img ? (img.getAttribute('src') || img.getAttribute('data-src') || '') : '';
    if (!src) return '';
    size = size || 120;
    if (/[?&]width=\d+/.test(src)) return src.replace(/width=\d+/, 'width=' + size).replace(/height=\d+/, 'height=' + size);
    return src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=' + size + '&height=' + size;
  }
  function getVals(o) { try { return ap.getValues(o.id) || []; } catch (err) { return []; } }
  function roName(t) { return String(t || '').trim().replace(/\bCires\b/g, 'Cireș'); }
  function domTitle(o) {
    var el = apoOptEl(o.id), t = el && el.querySelector('label.mw-label .mw-text--style-strong');
    var s = t ? String(t.textContent || '').trim() : '';
    return s || String(o.title || '').trim();
  }

  function roleOf(o, vs) {
    var t = norm(o.title);
    for (var i = 0; i < ROLES.length; i++) {
      var r = ROLES[i];
      if (!r[1].test(t)) continue;
      if (r[0] === 'usb') return o.required ? 'x' : 'usb';
      if (r[2] && !vs.some(function (v) { return r[2].test(v.title || ''); })) return 'x';
      return r[0];
    }
    return 'x';
  }
  /* Cheia (v) și eticheta unei valori APO, după rolul rândului; null = nu se arată (de ex. „Alta Dimensiune?”). */
  function keyOf(role, v) {
    var t = String(v.title || '').trim(), n = norm(t), m;
    if (role === 'a' || role === 'b' || role === 'c') { m = NUM_RX.exec(t); return m ? [+m[1], m[1] + ' cm'] : null; }
    if (role === 'bed') { m = BED_RX.exec(t); return m ? [m[1] + 'x' + m[2], m[1] + ' × ' + m[2] + ' cm'] : null; }
    if (role === 'corner') return /stang/.test(n) ? ['stânga', 'pe stânga'] : /dreap/.test(n) ? ['dreapta', 'pe dreapta'] : null;
    if (role === 'comfort') return /ultra/.test(n) ? ['Ultra', 'Ultra Confort'] : ['Standard', 'Standard'];
    if (role === 'storage') return /^da\b/.test(n) ? ['Da', 'Cu ladă'] : /^nu\b/.test(n) ? ['Nu', 'Fără ladă'] : (t ? [t, t] : null);
    if (role === 'legs') return t ? [t, roName(t)] : null;
    return t ? [t, t] : null;
  }

  function buildModel() {
    var st = ap.getState();
    FABO = { std: [], prem: [] };
    var groups = {}, order = [];
    (st.options || []).forEach(function (o) {
      var vs = getVals(o), r = roleOf(o, vs);
      if (r === 'fabStd') { FABO.std.push(o); return; }
      if (r === 'fabPrem') { FABO.prem.push(o); return; }
      if (r === 'usb') return; // Priza USB: nu se arată și nu se alege
      var key = r === 'x' ? 'x' + o.id : r;
      if (!groups[key]) { groups[key] = { key: key, role: r, copies: [], data: [] }; order.push(key); }
      groups[key].copies.push(o); groups[key].data.push({ o: o, vs: vs });
    });
    ROWS = order.map(function (key) {
      var g = groups[key], role = g.role;
      var row = { key: key, role: role, copies: g.copies, active: [], vals: [], byV: {}, other: null, allIds: [], text: false };
      row.rawTitle = g.copies[0].title;
      row.title = role === 'x' ? domTitle(g.copies[0]) : '';
      var maps = [];
      g.data.forEach(function (d) {
        d.vs.forEach(function (v) { row.allIds.push(v.id); });
        var activeCopy = !d.o.hidden && (d.vs.length ? d.vs.some(function (v) { return !v.hiddenByRule; }) : true);
        if (!activeCopy) return;
        row.active.push(d.o);
        var mp = { order: [], by: {}, other: null };
        d.vs.forEach(function (v) {
          var kk = keyOf(role, v);
          if (!kk) { if (!mp.other) mp.other = v; return; }
          if (mp.by[kk[0]]) return;
          mp.by[kk[0]] = { v: v, label: kk[1] }; mp.order.push(kk[0]);
        });
        maps.push({ o: d.o, mp: mp, n: d.vs.length });
      });
      if (maps.length) {
        var first = maps[0].mp;
        row.other = first.other;
        first.order.forEach(function (k) {
          if (!maps.every(function (x) { return x.mp.by[k]; })) return;
          var ids = {}, price = 0, hidden = false, avail = true;
          maps.forEach(function (x) { var e = x.mp.by[k].v; ids[x.o.id] = e.id; price += Number(e.price) || 0; if (e.hiddenByRule) hidden = true; if (e.available === false) avail = false; });
          var e0 = first.by[k].v;
          var val = { v: k, label: first.by[k].label, title: e0.title, ids: ids, price: price, hidden: hidden, avail: avail, tip: tipOf(e0.id) };
          if (role === 'legs' || role === 'x') val.img = swatchOf(e0.id, 100);
          row.vals.push(val); row.byV[k] = val;
        });
        if (role === 'a' || role === 'b' || role === 'c') row.vals.sort(function (p, q) { return p.v - q.v; });
        if (role === 'storage') row.vals.sort(function (p, q) { return (p.v === 'Da' ? 0 : 1) - (q.v === 'Da' ? 0 : 1); });
        if (maps.length > 1 && !warned[key]) { warned[key] = 1; try { console.warn('[E] opțiune dublată în APO', role, maps.map(function (x) { return x.o.id; })); } catch (_) {} }
        if (role === 'x' && !maps[0].n) row.text = true;
      }
      row.required = row.active.some(function (o) { return o.required; }) || PSEUDO_RE.test(norm(row.rawTitle)) || role === 'corner';
      row.vis = row.active.length > 0 && (row.vals.length > 0 || (row.text && row.required));
      return row;
    });
    ROWS.sort(function (p, q) { return ORDER.indexOf(p.role) - ORDER.indexOf(q.role); });
    M = {};
    ROWS.forEach(function (r) { if (r.vis) M[r.key] = r; });
    buildFabrics();
    if (FAB.length) { var fr = { key: 'fabric', role: 'fabric', required: true, vis: true, vals: [], byV: {} }; ROWS.push(fr); M.fabric = fr; }
    REQ = ROWS.filter(function (r) { return r.vis && r.required; }).map(function (r) { return r.key; });
    ROWS.forEach(function (r) { if (!(r.key in S)) S[r.key] = null; });
    LAY = (M.a && M.b) ? 'L' : M.a ? 'rect' : M.bed ? 'bed' : 'none';
    var selSum = 0, sel = [];
    try { sel = st.selections || ap.getSelections() || []; } catch (err) {}
    ROWS.forEach(function (r) { r.vals.forEach(function (x) { var ids = vals(x.ids); if (ids.length && ids.every(function (id) { return sel.indexOf(id) >= 0; })) selSum += x.price; }); });
    sel.forEach(function (id) { if (FABID[id]) selSum += FABID[id].price; });
    if (Number(st.price) > 0) BASE = Number(st.price) - selSum;
  }

  /* Ce se vede pe fiecare rând: litera și denumirea depind de desen (colțar L / canapea, fotoliu). */
  function LB(k) {
    var L = LAY === 'L';
    if (k === 'a') return L ? ['A', 'Partea lungă', 'partea lungă'] : FOT ? ['A', 'Lățimea', 'lățimea'] : ['A', 'Lungimea', 'lungimea'];
    if (k === 'b') return ['B', 'Partea scurtă', 'partea scurtă'];
    if (k === 'c') return L ? ['C', 'Adâncimea', 'adâncimea'] : ['B', 'Adâncimea', 'adâncimea'];
    if (k === 'bed') return [null, 'Mărimea patului', 'mărimea patului'];
    return null;
  }
  function rowTitle(k) {
    var r = M[k] || ROWS.filter(function (x) { return x.key === k; })[0];
    if (!r) return '';
    if (LB(r.role)) return LB(r.role)[1];
    return { corner: 'Colțul', comfort: 'Confortul', legs: 'Picioarele', storage: 'Lada de depozitare', fabric: 'Stofa' }[r.role] || r.title;
  }
  function missOf(k) {
    var r = M[k]; if (!r) return k;
    if (LB(r.role)) return LB(r.role)[2];
    return { corner: 'colțul', comfort: 'confortul', legs: 'picioarele', storage: 'lada', fabric: 'stofa' }[r.role] || String(r.title || '').toLowerCase();
  }

  /* Stofele: Standard (o grupă) + Premium pe familii (primul cuvânt din nume); prețul fiecărei stofe vine din APO. */
  var NOTES = {};
  String(D.famNotes || '').split(/\n/).forEach(function (ln) {
    var p = ln.split(':'); if (p.length < 2) return;
    NOTES[p[0].trim().toLowerCase()] = p.slice(1).join(':').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  });
  function tagsOf(fam) { return NOTES[String(fam).toLowerCase()] || []; }
  function buildFabrics() {
    FAB = []; FABN = {}; FABID = {}; FAMS = []; GROUPS = [];
    var famIdx = {};
    [['std', FABO.std[0]], ['prem', FABO.prem[0]]].forEach(function (pair) {
      var o = pair[1]; if (!o || o.hidden) return;
      var list = [];
      getVals(o).forEach(function (v) {
        var name = String(v.title || '').trim();
        if (!name || FABN[name]) return;
        var f = { id: v.id, opt: pair[0], optId: o.id, name: name, fam: name.split(' ')[0], rest: name.split(' ').slice(1).join(' ') || name, price: Number(v.price) || 0, hidden: !!v.hiddenByRule };
        list.push(f); FABN[name] = f; FABID[v.id] = f;
      });
      /* O familie cu o singură stofă și nume aproape la fel ca alta (greșeală de scriere în APO) intră în familia aceea. */
      var count = {};
      list.forEach(function (f) { count[f.fam] = (count[f.fam] || 0) + 1; });
      list.forEach(function (f) {
        if (count[f.fam] === 1) {
          for (var k in count) { if (k !== f.fam && count[k] > 1 && k.slice(0, 4).toLowerCase() === f.fam.slice(0, 4).toLowerCase()) { f.fam = k; break; } }
        }
      });
      list.forEach(function (f) {
        var key = pair[0] + ':' + f.fam;
        if (!famIdx[key]) { famIdx[key] = { fam: f.fam, opt: pair[0], items: [] }; FAMS.push(famIdx[key]); }
        famIdx[key].items.push(f);
        FAB.push(f);
      });
    });
    FAMS.forEach(function (g) { var ps = g.items.map(function (f) { return f.price; }); g.min = Math.min.apply(null, ps); g.max = Math.max.apply(null, ps); g.tags = tagsOf(g.fam); });
    var std = FAMS.filter(function (g) { return g.opt === 'std'; });
    if (std.length) {
      var items = []; std.forEach(function (g) { items = items.concat(g.items); });
      var ps = items.map(function (f) { return f.price; });
      GROUPS.push({ t: 'Standard', s: culori(items.length), min: Math.min.apply(null, ps), max: Math.max.apply(null, ps), k: 'inc', items: items, fams: std });
    }
    FAMS.filter(function (g) { return g.opt === 'prem'; }).forEach(function (g) {
      var tg = g.tags;
      GROUPS.push({ t: g.fam, s: 'Premium' + (tg.length ? ', ' + tg.join(', ') : ''), min: g.min, max: g.max, k: 'prem' + (tg.indexOf('anti-pată') >= 0 ? ' ap' : ''), items: g.items, fams: [g] });
    });
    GROUPS.forEach(function (gr) { if (gr.k === 'inc' && gr.max > 0) gr.k = 'prem'; });
  }
  function fabDropIds() { var ids = []; FABO.std.concat(FABO.prem).forEach(function (o) { getVals(o).forEach(function (v) { ids.push(v.id); }); }); return ids; }
  function grpPrice(min, max) { if (!min && !max) return 'inclusă în preț'; return min === max ? sg(max) : 'de la ' + sg(min || max); }
  function fabPriceTxt(f) { return f && f.price ? sg(f.price) : 'inclusă în preț'; }
  function fabCount() { return FAB.length; }
  function fabPaid() { return !FAB.length || FAB.some(function (f) { return f.price; }); }

  /* ---------- Totalul: întotdeauna cel din APO ---------- */
  function total() {
    if (ap) { try { var p = Number(ap.getState().price); if (p > 0) return p; } catch (err) {} }
    return BASE;
  }
  /* Prețul tăiat, ca în configuratorul 3D: prețul final / 0,6 (sau raportul produsului, dacă e altul) */
  function strike(p) {
    var b = Number(D.base) || 0, c = Number(D.compare) || 0;
    if (!p || !b || !c || c <= b) return 0;
    var r = c / b;
    return Math.abs(r - 1 / 0.6) < 0.002 ? Math.floor(p / 0.6 + 1e-6) : Math.floor(p * r);
  }
  function setOld(el, p) { if (!el) return; var o = strike(p); el.hidden = !(o > p); if (o > p) { el.textContent = lei(o); el.setAttribute('aria-label', 'Preț fără reducere ' + lei(o)); } }

  /* Din selecțiile APO în S (APO e sursa de adevăr): pe fiecare rând, valoarea ale cărei id-uri sunt toate alese. */
  function selNow() { try { return ap.getSelections() || []; } catch (err) { return []; } }
  function textInput(r) { var el = apoOptEl(r.copies[0].id); return el ? el.querySelector('input:not([type=hidden]):not([type=radio]):not([type=checkbox]), textarea') : null; }
  function syncFromApo() {
    if (!ap) return;
    var sel = selNow();
    var has = function (id) { return sel.indexOf(id) >= 0; };
    ROWS.forEach(function (r) {
      if (r.role === 'fabric') return;
      if (r.text) { var ti = textInput(r); S[r.key] = ti && ti.value.trim() ? ti.value.trim() : null; return; }
      var hit = null;
      var hitIds = null;
      if (M[r.key]) r.vals.forEach(function (x) { var ids = vals(x.ids); if (ids.length && ids.every(has)) { hit = x.v; hitIds = ids; } });
      if (hit !== null && !touched[r.key] && hitIds.every(function (id) { return DEF.indexOf(id) >= 0; })) hit = null;
      S[r.key] = hit;
    });
    var f = null; FAB.forEach(function (x) { if (has(x.id) && (touched.fabric || DEF.indexOf(x.id) < 0)) f = x; });
    S.fabric = f ? f.name : null; S.fam = f ? f.fam : null;
  }

  /* ap.setValue(id, true) nu scoate valoarea veche din aceeași opțiune: APO păstrează valoarea aflată mai jos în listă.
     De aceea trimitem selecția completă: tot ce era ales, fără valorile rândului (din toate copiile lui; la stofă, ale ambelor opțiuni),
     plus valoarea nouă (în fiecare copie activă). */
  function apoPick(k, v) {
    if (!ap) return false;
    try {
      var target, drop;
      if (k === 'fabric') {
        var f = FABN[v]; if (!f) return false;
        target = [f.id]; drop = fabDropIds();
      } else {
        var r = M[k], x = r && r.byV[v]; if (!x) return false;
        target = vals(x.ids); drop = r.allIds;
      }
      var keep = selNow().filter(function (id) { return drop.indexOf(id) < 0; });
      ap.setValues(keep.concat(target));
      var now = selNow();
      return target.every(function (id) { return now.indexOf(id) >= 0; });
    } catch (err) { return false; }
  }

  /* Prețul „de la”: totalul de acum (fără alegeri, prețul de bază din APO). */
  function fromPrice() { return total(); }

  /* ---------- Desenul la scară, care crește cu mărimea aleasă ---------- */
  function rng(k) { var m = M[k]; return m && m.vals.length && typeof m.vals[0].v === 'number' ? [m.vals[0].v, m.vals[m.vals.length - 1].v] : null; }
  function inclMax(k) { var m = M[k]; if (!m) return null; var r = null; m.vals.forEach(function (x) { if (!x.price && (r === null || x.v > r)) r = x.v; }); return r; }
  function defDim(k) { var r = rng(k); if (k === 'c') return r ? r[0] : 95; var i = inclMax(k); return i || (r ? r[0] : (k === 'a' ? 230 : 150)); }
  function maxDim(k) { var r = rng(k); return r ? r[1] : (k === 'a' ? 320 : k === 'b' ? 260 : 110); }
  /* Pasul: cea mai mică diferență între două valori vecine (5 cm azi peste tot). */
  function step(k) {
    var m = M[k]; if (!m || m.vals.length < 2) return null;
    var d = null; for (var i = 1; i < m.vals.length; i++) { var x = m.vals[i].v - m.vals[i - 1].v; if (x > 0 && (d === null || x < d)) d = x; }
    return d;
  }
  function sizeStep() { return step('a') || step('b') || step('c') || 5; }
  function bedParse(v) { var p = String(v || '').split('x'); return { W: +p[0] || 140, L: +p[1] || 200 }; }
  function bedDef() { var m = M.bed; if (!m) return null; var z = m.vals.filter(function (x) { return !x.price; })[0] || m.vals[0]; return z; }
  function bedMax() { var w = 0, l = 0; (M.bed ? M.bed.vals : []).forEach(function (x) { var b = bedParse(x.v); if (b.W * b.L > w * l) { w = b.W; l = b.L; } }); return { W: w || 200, L: l || 200 }; }

  function planScale(o) {
    var W = 358, m = !!o.mirror, X = function (x) { return m ? W - x : x; }, anc = function (a) { return m ? (a === 'start' ? 'end' : a === 'end' ? 'start' : a) : a; };
    var k = o.k, x0 = o.x0, y0 = o.y0, x1 = x0 + o.A * k, y1 = y0 + o.C * k, xs = x0 + o.C * k, yb = y0 + o.B * k;
    var on = function (q) { return o.active === q; }, ch = o.chosen || {};
    var poly = function (a, b) { return [[x0, y0], [a, y0], [a, y1], [xs, y1], [xs, b], [x0, b]].map(function (p) { return X(p[0]) + ',' + p[1]; }).join(' '); };
    var s = '<svg viewBox="0 0 ' + W + ' ' + o.H + '" font-family="Inter, system-ui, sans-serif">';
    var gx1 = x0 + o.maxA * k, gyb = y0 + o.maxB * k;
    s += '<polygon points="' + poly(gx1, gyb) + '" fill="none" stroke="#9C8F84" stroke-width="1" stroke-dasharray="4 3" stroke-linejoin="round"/>';
    s += '<text x="' + X(gx1) + '" y="' + (gyb + 16) + '" text-anchor="' + anc('end') + '" font-size="12" fill="#5F5F5F">linia punctată: maximum ' + o.maxA + ' × ' + o.maxB + ' cm</text>';
    s += '<polygon points="' + poly(x1, yb) + '" fill="#FFFFFF" stroke="' + ink + '" stroke-width="1.5" stroke-linejoin="round"/>';
    var bk = 17 * k, arm = 12 * k;
    s += '<path d="M' + X(x0 + bk) + ' ' + yb + 'V' + (y0 + bk) + 'H' + X(x1 - arm) + '" fill="none" stroke="' + soft + '" stroke-width="1"/>';
    s += '<rect x="' + Math.min(X(x1 - arm), X(x1)) + '" y="' + y0 + '" width="' + arm + '" height="' + (y1 - y0) + '" fill="#EFE8E0" stroke="' + ink + '" stroke-width="1.2"/>';
    var c1 = xs + (x1 - arm - xs) / 2;
    s += '<path d="M' + X(xs) + ' ' + (y0 + bk) + 'V' + y1 + 'M' + X(c1) + ' ' + (y0 + bk) + 'V' + y1 + '" stroke="' + soft + '" stroke-width="1" stroke-dasharray="3 3"/>';
    if (on('a')) s += '<path d="M' + X(x0) + ' ' + y0 + 'H' + X(x1) + '" stroke="' + acc + '" stroke-width="3.5" stroke-linecap="round"/>';
    if (on('b')) s += '<path d="M' + X(x0) + ' ' + y0 + 'V' + yb + '" stroke="' + acc + '" stroke-width="3.5" stroke-linecap="round"/>';
    if (on('c')) s += '<path d="M' + X(x1) + ' ' + y0 + 'V' + y1 + '" stroke="' + acc + '" stroke-width="3.5" stroke-linecap="round"/>';
    var ya = y0 - 14, xb = x0 - 12, xc = x1 + 12;
    var col = function (q) { return on(q) ? acc : (ch[q] ? accInk : ink); };
    s += '<g stroke-width="1">';
    s += '<path d="M' + X(x0) + ' ' + ya + 'H' + X(x1) + 'M' + X(x0) + ' ' + (ya - 4) + 'v8M' + X(x1) + ' ' + (ya - 4) + 'v8" stroke="' + col('a') + '"/>';
    s += '<path d="M' + X(xb) + ' ' + y0 + 'V' + yb + 'M' + X(xb - 4) + ' ' + y0 + 'h8M' + X(xb - 4) + ' ' + yb + 'h8" stroke="' + col('b') + '"/>';
    s += '<path d="M' + X(xc) + ' ' + y0 + 'V' + y1 + 'M' + X(xc - 4) + ' ' + y0 + 'h8M' + X(xc - 4) + ' ' + y1 + 'h8" stroke="' + col('c') + '"/>';
    s += '</g>';
    var tx = function (x, y, a, t, q, size, w) { return '<text x="' + X(x) + '" y="' + y + '" text-anchor="' + anc(a) + '" font-size="' + (size || 13) + '" font-weight="' + (w || 600) + '" fill="' + ((ch[q] || on(q)) ? accInk : ink) + '">' + t + '</text>'; };
    var mid = (x0 + x1) / 2, la = ch.a ? ('A · ' + ch.a + ' cm') : 'A · partea lungă', lw = ch.a ? 84 : 116;
    s += '<rect x="' + (X(mid) - lw / 2) + '" y="' + (ya - 10) + '" width="' + lw + '" height="20" fill="#F6F2EE"/>';
    s += tx(mid, ya + 4.5, 'middle', la, 'a');
    var lb = ch.b ? ['B', ch.b + ' cm'] : ['B', 'partea', 'scurtă'], by = (y0 + yb) / 2 - ((lb.length - 1) * 8);
    lb.forEach(function (t, i) { s += tx(xb - 8, by + i * 16 + 4, 'end', t, 'b', i === 0 ? 13 : 12, i === 0 ? 700 : 400); });
    var cl = ch.c ? ('C · ' + ch.c + ' cm') : 'C · adâncimea';
    if (o.compact) { var cw = ch.c ? 74 : 94, cx = xc + 6, cy = (y0 + y1) / 2; s += '<rect x="' + (m ? X(cx) - cw : X(cx)) + '" y="' + (cy - 10) + '" width="' + cw + '" height="20" fill="#F6F2EE"/>'; s += tx(cx + 2, cy + 4.5, 'start', cl, 'c', 13, 600); }
    else s += tx(xc + 4, y1 + 18, 'end', cl, 'c', 13, 600);
    if (!o.compact) s += '<text x="' + X(x0) + '" y="' + (o.H - 8) + '" text-anchor="' + anc('start') + '" font-size="12" fill="#5F5F5F">vedere de sus · colțul pe ' + (m ? 'dreapta' : 'stânga') + '</text>';
    return s + '</svg>';
  }
  function planFixed(o) {
    var W = 358, m = !!o.mirror, X = function (x) { return m ? W - x : x; }, anc = function (a) { return m ? (a === 'start' ? 'end' : a === 'end' ? 'start' : a) : a; };
    var x0 = o.x0, x1 = 338, y0 = o.y0, d = o.d, sw = o.sw, yb = o.yb, xs = x0 + sw, y1 = y0 + d, chosen = o.chosen || {};
    var pts = [[x0, y0], [x1, y0], [x1, y1], [xs, y1], [xs, yb], [x0, yb]].map(function (p) { return X(p[0]) + ',' + p[1]; }).join(' ');
    var s = '<svg viewBox="0 0 ' + W + ' ' + o.h + '" font-family="Inter, system-ui, sans-serif" role="img" aria-label="Vedere de sus: A partea lungă, B partea scurtă, C adâncimea">';
    s += '<polygon points="' + pts + '" fill="#FFFFFF" stroke="' + ink + '" stroke-width="1.5" stroke-linejoin="round"/>';
    s += '<path d="M' + X(x0 + 9) + ' ' + yb + 'V' + (y0 + 9) + 'H' + X(x1 - 13) + '" fill="none" stroke="' + soft + '" stroke-width="1"/>';
    s += '<rect x="' + Math.min(X(x1 - 13), X(x1)) + '" y="' + y0 + '" width="13" height="' + d + '" fill="#EFE8E0" stroke="' + ink + '" stroke-width="1.2"/>';
    var c1 = x0 + sw + (x1 - 13 - xs) / 2;
    s += '<path d="M' + X(xs) + ' ' + (y0 + 9) + 'V' + y1 + 'M' + X(c1) + ' ' + (y0 + 9) + 'V' + y1 + '" stroke="' + soft + '" stroke-width="1" stroke-dasharray="3 3"/>';
    var ya = y0 - 14, xb = x0 - 14, xc = x1 + 12;
    var col = function (k) { return chosen[k] ? accInk : ink; };
    s += '<g stroke-width="1">';
    s += '<path d="M' + X(x0) + ' ' + ya + 'H' + X(x1) + 'M' + X(x0) + ' ' + (ya - 4) + 'v8M' + X(x1) + ' ' + (ya - 4) + 'v8" stroke="' + col('a') + '"/>';
    s += '<path d="M' + X(xb) + ' ' + y0 + 'V' + yb + 'M' + X(xb - 4) + ' ' + y0 + 'h8M' + X(xb - 4) + ' ' + yb + 'h8" stroke="' + col('b') + '"/>';
    s += '<path d="M' + X(xc) + ' ' + y0 + 'V' + y1 + 'M' + X(xc - 4) + ' ' + y0 + 'h8M' + X(xc - 4) + ' ' + y1 + 'h8" stroke="' + col('c') + '"/>';
    s += '</g>';
    var tx = function (x, y, a, txt, k, size, w) { return '<text x="' + X(x) + '" y="' + y + '" text-anchor="' + anc(a) + '" font-size="' + (size || 13) + '" font-weight="' + (w || 600) + '" fill="' + (chosen[k] ? accInk : ink) + '">' + txt + '</text>'; };
    var mid = (x0 + x1) / 2, la = o.labels.a;
    s += '<rect x="' + (X(mid) - la.w / 2) + '" y="' + (ya - 10) + '" width="' + la.w + '" height="20" fill="#FFFFFF"/>';
    s += tx(mid, ya + 4.5, 'middle', la.t, 'a');
    var lb = o.labels.b, by = (y0 + yb) / 2 - ((lb.length - 1) * 8);
    lb.forEach(function (t, i) { s += tx(xb - 8, by + i * 16 + 4, 'end', t, 'b', i === 0 ? 13 : 12, i === 0 ? 700 : 400); });
    o.labels.c.forEach(function (t, i) { s += tx(x1 + 16, y1 + 22 + i * 16, 'end', t, 'c', i === 0 ? 13 : 12, i === 0 ? 700 : 400); });
    return s + '</svg>';
  }
  /* Canapea, fotoliu: un dreptunghi A × B, cu spătarul sus și cotierele la capete. */
  function planRect(o) {
    /* Etichetele adâncimii stau în dreapta liniei punctate (maximum), nu peste ea: lățimea lor decide cât loc rămâne desenului. */
    var labW = 0; if (M.c) (o.lc || []).forEach(function (t, i) { labW = Math.max(labW, String(t).length * (i === 0 ? 7.6 : 6.8)); });
    var W = 358, k = o.k, rw = Math.max(o.rw || 84, Math.round(labW + 26));
    if (o.maxA * k > W - 28 - rw) k = (W - 28 - rw) / o.maxA;
    var gA = o.maxA * k, gC = o.maxC * k;
    var x0 = Math.max(14, Math.round((W - gA - rw) / 2)), y0 = o.y0, x1 = x0 + o.A * k, y1 = y0 + o.C * k, gx1 = x0 + gA, gy1 = y0 + gC;
    var H = Math.round(gy1 + (o.compact ? 26 : 46));
    var on = function (q) { return o.active === q; }, ch = o.chosen || {};
    var col = function (q) { return on(q) ? acc : (ch[q] ? accInk : ink); };
    var fillOf = function (q) { return (ch[q] || on(q)) ? accInk : ink; };
    var s = '<svg viewBox="0 0 ' + W + ' ' + H + '" font-family="Inter, system-ui, sans-serif"' + (o.aria ? ' role="img" aria-label="' + esc(o.aria) + '"' : '') + '>';
    s += '<rect x="' + x0 + '" y="' + y0 + '" width="' + gA + '" height="' + gC + '" fill="none" stroke="#9C8F84" stroke-width="1" stroke-dasharray="4 3"/>';
    var mt = 'linia punctată: maximum ' + o.maxA + ' × ' + o.maxC + ' cm';
    s += '<text x="' + Math.max(gx1, Math.min(W - 4, x0 + 236)) + '" y="' + (gy1 + 16) + '" text-anchor="end" font-size="12" fill="#5F5F5F">' + mt + '</text>';
    s += '<rect x="' + x0 + '" y="' + y0 + '" width="' + (x1 - x0) + '" height="' + (y1 - y0) + '" fill="#FFFFFF" stroke="' + ink + '" stroke-width="1.5"/>';
    var bk = (num(T.back) || 17) * k, arm = NOARMS ? 0 : (num(T.armW) || 12) * k;
    s += '<path d="M' + (x0 + arm) + ' ' + (y0 + bk) + 'H' + (x1 - arm) + '" fill="none" stroke="' + soft + '" stroke-width="1"/>';
    if (arm) {
      s += '<rect x="' + x0 + '" y="' + y0 + '" width="' + arm + '" height="' + (y1 - y0) + '" fill="#EFE8E0" stroke="' + ink + '" stroke-width="1.2"/>';
      s += '<rect x="' + (x1 - arm) + '" y="' + y0 + '" width="' + arm + '" height="' + (y1 - y0) + '" fill="#EFE8E0" stroke="' + ink + '" stroke-width="1.2"/>';
    }
    var cm = (x0 + x1) / 2;
    s += '<path d="M' + cm + ' ' + (y0 + bk) + 'V' + y1 + '" stroke="' + soft + '" stroke-width="1" stroke-dasharray="3 3"/>';
    if (on('a')) s += '<path d="M' + x0 + ' ' + y0 + 'H' + x1 + '" stroke="' + acc + '" stroke-width="3.5" stroke-linecap="round"/>';
    if (on('c')) s += '<path d="M' + x1 + ' ' + y0 + 'V' + y1 + '" stroke="' + acc + '" stroke-width="3.5" stroke-linecap="round"/>';
    var ya = y0 - 14, xc = Math.max(x1, gx1) + 12;
    s += '<g stroke-width="1">';
    s += '<path d="M' + x0 + ' ' + ya + 'H' + x1 + 'M' + x0 + ' ' + (ya - 4) + 'v8M' + x1 + ' ' + (ya - 4) + 'v8" stroke="' + col('a') + '"/>';
    if (M.c) s += '<path d="M' + xc + ' ' + y0 + 'V' + y1 + 'M' + (xc - 4) + ' ' + y0 + 'h8M' + (xc - 4) + ' ' + y1 + 'h8" stroke="' + col('c') + '"/>';
    s += '</g>';
    var lw = Math.round(o.la.length * 7.4 + 12);
    s += '<rect x="' + ((x0 + x1) / 2 - lw / 2) + '" y="' + (ya - 10) + '" width="' + lw + '" height="20" fill="' + (o.bg || '#F6F2EE') + '"/>';
    s += '<text x="' + ((x0 + x1) / 2) + '" y="' + (ya + 4.5) + '" text-anchor="middle" font-size="13" font-weight="600" fill="' + fillOf('a') + '">' + o.la + '</text>';
    if (M.c) {
      var lc = o.lc, cy = (y0 + y1) / 2 - ((lc.length - 1) * 8);
      lc.forEach(function (t, i) { s += '<text x="' + (xc + 8) + '" y="' + (cy + i * 16 + 4) + '" text-anchor="start" font-size="' + (i === 0 ? 13 : 12) + '" font-weight="' + (i === 0 ? 700 : 400) + '" fill="' + fillOf('c') + '">' + t + '</text>'; });
    }
    if (!o.compact) s += '<text x="' + x0 + '" y="' + (H - 8) + '" text-anchor="start" font-size="12" fill="#5F5F5F">vedere de sus</text>';
    return s + '</svg>';
  }
  /* Pat: salteaua W × L, cu tăblia sus și două perne. */
  function planBed(o) {
    var Wv = 358, k = o.k, w = o.W * k, l = o.L * k, gw = o.Wmax * k, gl = o.Lmax * k;
    var x0 = Math.max(84, Math.round((Wv - gw) / 2) + 20), y0 = o.y0, x1 = x0 + w, y1 = y0 + l;
    var H = Math.round(y0 + gl + (o.compact ? 26 : 46)), hb = 8 * k, ch = !!o.chosen;
    var fill = ch ? accInk : ink;
    var s = '<svg viewBox="0 0 ' + Wv + ' ' + H + '" font-family="Inter, system-ui, sans-serif"' + (o.aria ? ' role="img" aria-label="' + esc(o.aria) + '"' : '') + '>';
    s += '<rect x="' + x0 + '" y="' + y0 + '" width="' + gw + '" height="' + gl + '" fill="none" stroke="#9C8F84" stroke-width="1" stroke-dasharray="4 3"/>';
    s += '<text x="' + Math.max(x0 + gw, Math.min(Wv - 4, x0 + 250)) + '" y="' + (y0 + gl + 16) + '" text-anchor="end" font-size="12" fill="#5F5F5F">linia punctată: cea mai mare, ' + o.Wmax + ' × ' + o.Lmax + ' cm</text>';
    s += '<rect x="' + x0 + '" y="' + y0 + '" width="' + w + '" height="' + l + '" rx="4" fill="#FFFFFF" stroke="' + ink + '" stroke-width="1.5"/>';
    s += '<rect x="' + x0 + '" y="' + y0 + '" width="' + w + '" height="' + hb + '" fill="#EFE8E0" stroke="' + ink + '" stroke-width="1.2"/>';
    var g = 6, pw = (w - 3 * g) / 2, ph = Math.max(10, l * 0.13);
    s += '<rect x="' + (x0 + g) + '" y="' + (y0 + hb + g) + '" width="' + pw + '" height="' + ph + '" rx="6" fill="#F3EEE8" stroke="' + soft + '"/>';
    s += '<rect x="' + (x0 + 2 * g + pw) + '" y="' + (y0 + hb + g) + '" width="' + pw + '" height="' + ph + '" rx="6" fill="#F3EEE8" stroke="' + soft + '"/>';
    var ya = y0 - 14, xb = x0 - 12;
    s += '<g stroke-width="1" stroke="' + (ch ? accInk : ink) + '"><path d="M' + x0 + ' ' + ya + 'H' + x1 + 'M' + x0 + ' ' + (ya - 4) + 'v8M' + x1 + ' ' + (ya - 4) + 'v8"/>';
    s += '<path d="M' + xb + ' ' + y0 + 'V' + y1 + 'M' + (xb - 4) + ' ' + y0 + 'h8M' + (xb - 4) + ' ' + y1 + 'h8"/></g>';
    var lt = 'lățime ' + o.W + ' cm', lw = Math.round(lt.length * 7.2 + 12);
    s += '<rect x="' + ((x0 + x1) / 2 - lw / 2) + '" y="' + (ya - 10) + '" width="' + lw + '" height="20" fill="' + (o.bg || '#F6F2EE') + '"/>';
    s += '<text x="' + ((x0 + x1) / 2) + '" y="' + (ya + 4.5) + '" text-anchor="middle" font-size="13" font-weight="600" fill="' + fill + '">' + lt + '</text>';
    var cy = (y0 + y1) / 2 - 8;
    s += '<text x="' + (xb - 8) + '" y="' + (cy + 4) + '" text-anchor="end" font-size="12" fill="' + fill + '">lungime</text>';
    s += '<text x="' + (xb - 8) + '" y="' + (cy + 20) + '" text-anchor="end" font-size="13" font-weight="700" fill="' + fill + '">' + o.L + ' cm</text>';
    if (!o.compact) s += '<text x="' + 8 + '" y="' + (H - 8) + '" text-anchor="start" font-size="12" fill="#5F5F5F">vedere de sus</text>';
    return s + '</svg>';
  }
  function rangeTxt(k, sep) { var r = rng(k); return r ? r[0] + (sep || '–') + r[1] + ' cm' : null; }
  var openKey = null, planCard = $('#e-planCard'), opts = $('#e-opts');
  function drawPlans() {
    if (!apoOk) return;
    var mini = $('#e-miniPlan'), big = $('#e-bigPlan'), cp = planCard.classList.contains('inrow');
    var y = $('#e-yours'), sc = $('#e-sideC');
    if (LAY === 'L') {
      var ch = { a: S.a, b: S.b, c: S.c }, active = (openKey === 'a' || openKey === 'b' || openKey === 'c') ? openKey : null, mirror = S.corner === 'dreapta';
      var mA = maxDim('a'), mB = maxDim('b');
      var dim = { mirror: mirror, A: S.a || defDim('a'), B: S.b || defDim('b'), C: S.c || defDim('c'), active: active, chosen: ch, maxA: mA, maxB: mB };
      var kk = cp ? Math.min(0.48, 154 / mA, 128 / mB) : Math.min(0.62, 198 / mA, 168 / mB);
      setH(mini, planScale(Object.assign(dim, cp ? { k: kk, x0: 80, y0: 30, H: 180, compact: true } : { k: kk, x0: 100, y0: 36, H: 244 })));
      var ra = rangeTxt('a'), rb = rangeTxt('b'), rc = M.c ? M.c.vals.map(function (x) { return x.v; }).join(' · ') + ' cm' : '';
      setH(big, planFixed({ mirror: mirror, x0: 104, y0: 40, d: 44, sw: 50, yb: 158, h: 172, chosen: ch,
        labels: { a: { t: S.a ? ('A · ' + S.a + ' cm') : ('A · partea lungă' + (ra ? ' · ' + ra : '')), w: S.a ? 92 : (ra ? 196 : 120) }, b: S.b ? ['B', S.b + ' cm'] : (rb ? ['B', 'partea scurtă', rb] : ['B', 'partea scurtă']), c: S.c ? ['C · ' + S.c + ' cm'] : (rc ? ['C · adâncimea', rc] : ['C · adâncimea']) } }));
      if (S.a || S.b || S.c) { y.classList.add('on'); y.textContent = 'Mărimea ta (A × B × C): ' + (S.a || '—') + ' × ' + (S.b || '—') + ' × ' + (S.c || '—') + ' cm'; }
      else y.classList.remove('on');
    } else if (LAY === 'rect') {
      var nm = FOT ? 'lățimea' : 'lungimea', act = (openKey === 'a' || openKey === 'c') ? openKey : null;
      var mA2 = maxDim('a'), mC = M.c ? maxDim('c') : 0, cA = S.a || defDim('a'), cC = M.c ? (S.c || defDim('c')) : 0;
      var base = { A: cA, C: cC, maxA: mA2, maxC: mC, active: act, chosen: { a: S.a, c: S.c } };
      if (!M.c) { base.C = 95; base.maxC = 95; }
      setH(mini, planRect(Object.assign({}, base, cp ? { k: Math.min(0.7, 200 / mA2, 110 / base.maxC), y0: 30, compact: true } : { k: Math.min(0.9, 238 / mA2, 150 / base.maxC), y0: 36 },
        { la: S.a ? 'A · ' + S.a + ' cm' : 'A · ' + nm, lc: S.c ? ['B', S.c + ' cm'] : ['B', 'adâncimea'] })));
      var rcv = M.c ? M.c.vals.map(function (x) { return x.v; }).join(' · ') + ' cm' : '';
      setH(big, planRect(Object.assign({}, base, { active: null, k: Math.min(0.8, 180 / mA2, 110 / base.maxC), y0: 40, rw: 150, bg: '#FFFFFF',
        aria: 'Vedere de sus: A ' + nm + ', B adâncimea', la: S.a ? 'A · ' + S.a + ' cm' : 'A · ' + nm + ' · ' + rangeTxt('a'), lc: S.c ? ['B · ' + S.c + ' cm'] : ['B · adâncimea', rcv] })));
      if (S.a && S.c) { y.classList.add('on'); y.textContent = 'Mărimea ta (A × B): ' + S.a + ' × ' + S.c + ' cm'; }
      else if (S.a && !M.c) { y.classList.add('on'); y.textContent = (FOT ? 'Lățimea ta: ' : 'Lungimea ta: ') + S.a + ' cm'; }
      else y.classList.remove('on');
    } else if (LAY === 'bed') {
      var bx = bedMax(), cur = S.bed ? bedParse(S.bed) : bedParse(bedDef().v);
      var bb = { W: cur.W, L: cur.L, Wmax: bx.W, Lmax: bx.L, chosen: !!S.bed };
      setH(mini, planBed(Object.assign({}, bb, cp ? { k: Math.min(0.6, 150 / bx.W, 120 / bx.L), y0: 30, compact: true } : { k: Math.min(0.9, 220 / bx.W, 200 / bx.L), y0: 36 })));
      setH(big, planBed(Object.assign({}, bb, { k: Math.min(0.8, 200 / bx.W, 180 / bx.L), y0: 36, bg: '#FFFFFF', aria: 'Vedere de sus: salteaua, lățime ' + cur.W + ' cm, lungime ' + cur.L + ' cm' })));
      if (S.bed) { y.classList.add('on'); y.textContent = 'Mărimea patului: ' + M.bed.byV[S.bed].label; } else y.classList.remove('on');
    }
    if (sc) {
      var ltr = LAY === 'L' ? 'C ' : 'B ', line = sc.parentNode;
      svHide('e-sv-cdim', !M.c);
      if (!M.c) line.setAttribute('display', 'none');
      else {
        line.removeAttribute('display');
        if (S.c) { sc.textContent = ltr + S.c + ' cm'; line.setAttribute('fill', accInk); } else { sc.textContent = ltr + rangeTxt('c'); line.setAttribute('fill', ink); }
      }
    }
  }

  /* ---------- Textele cu prețuri, toate din APO ---------- */
  function stepTxt(k) {
    var m = M[k]; if (!m) return '';
    var paid = m.vals.filter(function (x) { return x.price > 0; });
    if (!paid.length) return '';
    var d0 = null, cm0 = null, ok = true, prev = null;
    m.vals.forEach(function (x) {
      if (prev && x.price > 0) {
        var d = x.price - prev.price, c = x.v - prev.v;
        if (d0 === null) { d0 = d; cm0 = c; } else if (d !== d0 || c !== cm0) ok = false;
      }
      prev = x;
    });
    if (ok && d0 > 0) return 'Apoi +' + lei(d0) + ' la fiecare ' + cm0 + ' cm.';
    return 'Apoi prețul crește cu mărimea; îl vezi sub fiecare buton.';
  }
  function hintFor(k) {
    var i = inclMax(k), st = stepTxt(k), m = M[k];
    var neg = m ? m.vals.filter(function (x) { return !x.hidden && x.avail && x.price < 0; }) : [];
    var zero = m ? m.vals.filter(function (x) { return !x.price; }) : [];
    if (neg.length >= 2 && zero.length) {
      var z0 = zero[0].v, z1 = zero[zero.length - 1].v, inc = z0 === z1 ? z0 : z0 + '–' + z1;
      var d = /^Apoi \+([\d.]+ lei) la fiecare (\d+) cm/.exec(st);
      return '<b>' + inc + ' cm e inclus în preț.</b> ' + neg[0].v + '–' + neg[neg.length - 1].v + ' cm costă mai puțin (vezi sub fiecare buton)' +
        (d ? ', iar peste ' + z1 + ' cm, +' + d[1] + ' la fiecare ' + d[2] + ' cm. ' : (st ? ', iar peste ' + z1 + ' cm prețul crește cu mărimea. ' : '. '));
    }
    if (k === 'c') return i ? '<b>' + i + ' cm e inclus în preț.</b> ' : '';
    return i ? '<b>Inclusă în preț până la ' + i + ' cm.</b> ' + st + ' ' : (st ? st + ' ' : '');
  }
  function notesFor(k) {
    var m = M[k]; if (!m) return '';
    var out = [], run = null;
    m.vals.forEach(function (x) {
      if (x.tip && run && run.tip === x.tip && run.last + 5 >= x.v) { run.last = x.v; return; }
      if (run) out.push(run); run = x.tip ? { tip: x.tip, first: x.v, last: x.v } : null;
    });
    if (run) out.push(run);
    return out.map(function (r) { var t = r.tip.charAt(0).toLowerCase() + r.tip.slice(1); return '<li>* ' + (r.first === r.last ? r.first : r.first + '–' + r.last) + ' cm: ' + esc(t.replace(/\.$/, '')) + '.</li>'; }).join('');
  }
  function plText(k) {
    var r = M[k] || {};
    if (k === 'a' || k === 'b') {
      var i = inclMax(k), st = stepTxt(k);
      return (i ? 'inclusă până la ' + i + ' cm' : '') + (st ? (i ? ', ' : '') + st.replace(/^Apoi /, 'apoi ').replace(/\.$/, '') : '');
    }
    if (k === 'c') return M.c ? M.c.vals.map(function (x) { return x.v + ' cm ' + (x.price ? sg(x.price) : 'inclus'); }).join(' · ') : '';
    if (k === 'comfort') return M.comfort ? M.comfort.vals.map(function (x) { return (x.v === 'Ultra' ? 'Ultra, mai moale: ' : 'Standard, mai ferm: ') + (x.price ? sg(x.price) : 'inclus'); }).join(' · ') : '';
    if (k === 'fabric') {
      var std = GROUPS.filter(function (g) { return g.k === 'inc'; })[0];
      var prem = GROUPS.filter(function (g) { return g.k !== 'inc'; });
      var pc = 0; prem.forEach(function (g) { pc += g.items.length; });
      var t = std ? 'Standard: inclusă (' + culori(std.items.length) + ')' : '';
      if (prem.length) t += (t ? ' · ' : '') + 'Premium: ' + prem.map(function (g) { return (g.min !== g.max ? 'de la ' : '') + sg(g.min); }).join(' / ') + ' (' + culori(pc) + ')';
      return t;
    }
    if (r.role === 'bed') return r.vals.map(function (x) { return x.label + ' ' + (x.price ? sg(x.price) : 'inclus'); }).join(' · ');
    if (r.role === 'storage') return r.vals.map(function (x) { return x.label + ': ' + (x.price ? sg(x.price) : 'inclusă'); }).join(' · ');
    if (r.role === 'legs') { var all0 = r.vals.every(function (x) { return !x.price; }); return all0 ? r.vals.map(function (x) { return x.label; }).join(', ') + ' · fără cost' : r.vals.map(function (x) { return x.label + ' ' + (x.price ? sg(x.price) : 'inclus'); }).join(' · '); }
    if (r.role === 'x') return r.vals.map(function (x) { return x.label + (x.price ? ' ' + sg(x.price) : ''); }).join(' · ');
    return '';
  }

  /* ---------- Rândurile: grilele, adâncimile, cardurile (din APO) ---------- */
  function cell(k, x) {
    var small = (x.price ? sg(x.price) : 'inclus') + (x.tip ? '*' : '');
    return '<button class="cell" type="button" data-pick="' + k + '" data-v="' + x.v + '" aria-pressed="false"' + (x.hidden ? ' hidden' : '') + (x.avail ? '' : ' disabled') + ' aria-label="' + x.v + ' cm, ' + small.replace('*', '') + '"><span class="v">' + x.v + '<span> cm</span></span><small>' + small + '</small></button>';
  }
  function side(d, dmin) {
    var x = 5, w = 42 + (d - dmin) / 5 * 8, ex = w - 42;
    return '<svg viewBox="0 0 76 46" aria-hidden="true">' +
      (ex ? '<rect x="' + (x + 42) + '" y="17" width="' + ex + '" height="21" fill="#FCD9CB"/><path d="M' + (x + 42) + ' 15V40" stroke="' + acc + '" stroke-width="1.2" stroke-dasharray="2 2"/>' : '') +
      '<path d="M' + x + ' 38V8a4 4 0 0 1 4-4h5v13" fill="none" stroke="' + ink + '" stroke-width="1.4" stroke-linejoin="round"/>' +
      '<rect x="' + (x + 9) + '" y="17" width="' + (w - 9) + '" height="8" rx="3" fill="none" stroke="' + ink + '" stroke-width="1.4"/>' +
      '<path d="M' + x + ' 25H' + (x + w) + 'V38H' + x + 'Z" fill="none" stroke="' + ink + '" stroke-width="1.4" stroke-linejoin="round"/>' +
      '<path d="M' + (x + 3) + ' 38v3M' + (x + w - 3) + ' 38v3" stroke="' + ink + '" stroke-width="2"/></svg>';
  }
  function cardPrice(r, x) { return x.price ? sg(x.price) : (r.role === 'legs' || r.role === 'corner' ? 'fără cost' : 'inclus'); }
  function genRow(r) {
    var k = r.key, t = rowTitle(k), sub = '', notes = '', links = '', body;
    if (r.role === 'bed') {
      sub = 'lățime × lungime, în cm';
      var z = bedDef();
      notes = '<p class="hint"><b>' + esc(z.label) + ' e inclusă în preț.</b> Mărimea e a saltelei.</p>';
      links = '<div class="links"><a class="lnk wa" href="#" data-e-wa="other" target="_blank" rel="noopener"><svg class="i"><use href="#e-i-wa"/></svg>Altă mărime? Scrie-ne pe WhatsApp ›</a></div>';
    } else if (r.role === 'legs') {
      var all0 = r.vals.every(function (x) { return !x.price; });
      sub = culori(r.vals.length) + (all0 ? ', fără cost' : '');
      if (T.legsH) notes = '<ul class="notes"><li>Picioarele au ' + cmN(T.legsH) + ' cm înălțime.</li></ul>';
    } else if (r.role === 'storage') sub = 'cu sau fără';
    else sub = r.vals.length && r.vals.length <= 3 ? r.vals.map(function (x) { return x.label; }).join(' / ') : (r.vals.length ? r.vals.length + ' variante' : '');
    if (r.text) body = '<input class="e-txt" type="text" data-e-text="' + esc(k) + '" aria-label="' + esc(t) + '">';
    else body = '<div class="cards' + (r.vals.length >= 5 ? ' c3' : '') + '" role="group" aria-label="' + esc(t) + '">' + r.vals.map(function (x) {
      return '<button class="card" type="button" data-pick="' + esc(k) + '" data-v="' + esc(x.v) + '" aria-pressed="false"' + (x.hidden ? ' hidden' : '') + (x.avail ? '' : ' disabled') + '>' +
        (x.img ? '<img class="sw" src="' + esc(x.img) + '" alt="" loading="lazy" decoding="async" onerror="this.remove()">' : '') + '<b>' + esc(x.label) + '</b><em>' + cardPrice(r, x) + '</em></button>';
    }).join('') + '</div>';
    if (r.role === 'bed') body = notes + body, notes = '';
    return '<div class="opt gen" data-k="' + esc(k) + '" id="e-opt-' + esc(k) + '"><div class="opt-head"><span class="key"><svg class="i"><use href="#' + (ICON[r.role] || ICON.x) + '"/></svg></span>' +
      '<span class="opt-title">' + esc(t) + (r.required ? '' : ' <span class="u">(opțional)</span>') + (sub ? '<small>' + esc(sub) + '</small>' : '') + '</span><span class="opt-state"></span></div>' +
      '<div class="opt-body">' + body + notes + links + '</div></div>';
  }
  function relabel(k) {
    var row = $('#e-opt-' + k), lb = LB(k); if (!row || !lb) return;
    var key = $('.opt-head .key', row), tt = $('.opt-title', row);
    if (key && lb[0]) key.textContent = lb[0];
    if (tt && tt.firstChild && tt.firstChild.nodeType === 3) tt.firstChild.nodeValue = lb[1] + ' ';
    var g = $('[data-grid="' + k + '"]', row); if (g) g.setAttribute('aria-label', lb[1] + ', în centimetri');
    var pl = $('[data-e-pll="' + k + '"]'); if (pl) pl.textContent = lb[1] + ' (' + lb[0] + ')';
  }
  function renderRows() {
    ['a', 'b'].forEach(function (k) {
      var row = $('#e-opt-' + k);
      if (!M[k]) { row.hidden = true; return; }
      row.hidden = false; relabel(k);
      $('[data-grid="' + k + '"]').innerHTML = M[k].vals.map(function (x) { return cell(k, x); }).join('');
      $('[data-e-notes="' + k + '"]').innerHTML = notesFor(k);
      var r = rng(k), stp = step(k); $('[data-e-range="' + k + '"]').textContent = r[0] + '–' + r[1] + ' cm' + (stp ? ', din ' + stp + ' în ' + stp : '');
      var h = $('[data-e-hint="' + k + '"]'); if (!h.dataset.extra) h.dataset.extra = h.innerHTML; h.innerHTML = hintFor(k) + h.dataset.extra;
    });
    if (M.c) {
      $('#e-opt-c').hidden = false; relabel('c');
      var dmin = M.c.vals[0].v;
      $('#e-depths').innerHTML = M.c.vals.map(function (x) {
        var p = x.price ? sg(x.price) : 'inclus';
        return '<button class="dcard" type="button" data-pick="c" data-v="' + x.v + '" aria-pressed="false"' + (x.hidden ? ' hidden' : '') + (x.avail ? '' : ' disabled') + ' aria-label="' + x.v + ' cm, ' + p + '">' + side(x.v, dmin) + '<b>' + x.v + '<span> cm</span></b><small>' + p + '</small></button>';
      }).join('');
      var sc = step('c');
      $('[data-e-range="c"]').textContent = rangeTxt('c') + (sc ? ', din ' + sc + ' în ' + sc : '');
      var hc = $('[data-e-hint="c"]'); if (!hc.dataset.extra) hc.dataset.extra = hc.innerHTML; hc.innerHTML = hintFor('c') + hc.dataset.extra;
    } else $('#e-opt-c').hidden = true;
    $('#e-opt-corner').hidden = !M.corner;
    $('#e-opt-comfort').hidden = !M.comfort;
    $('#e-opt-fabric').hidden = !FAB.length;
    /* Rândurile generate: mărimea patului intră în pasul 1 (după adâncime); picioarele, lada și orice altă opțiune APO, în pasul 2. */
    $$('.opt.gen').forEach(function (o) { o.remove(); });
    ROWS.forEach(function (r) {
      if (!M[r.key] || ['bed', 'legs', 'storage', 'x'].indexOf(r.role) < 0) return;
      var tmp = document.createElement('div'); tmp.innerHTML = genRow(r);
      $('[data-rows="' + (r.role === 'bed' ? 'size' : 'opts') + '"]').appendChild(tmp.firstChild);
    });
    $$('.opt.gen [data-e-wa="other"]').forEach(function (a) { a.href = waLink('Bună ziua! Aș vrea o mărime care nu e pe site: … cm.\nProdus: ' + (D.title || SHORT) + '\n' + (D.url || '')); });
    $$('[data-e-px]').forEach(function (el) {
      var key = el.getAttribute('data-e-px'), p = key.split('-'), x = null;
      if (p[0] === 'corner' && M.corner) x = M.corner.byV[p[1]];
      if (p[0] === 'comfort' && M.comfort) x = M.comfort.byV[p[1]];
      if (x) { el.textContent = x.price ? sg(x.price) : (p[0] === 'corner' ? 'fără cost' : 'inclus'); el.closest('button').hidden = !!x.hidden; }
      else if (p[0] === 'corner' || p[0] === 'comfort') { var b = el.closest('button'); if (b && (p[0] === 'corner' ? M.corner : M.comfort)) b.hidden = true; }
      if (key === 'ultra-paren') el.textContent = (M.comfort && M.comfort.byV.Ultra && M.comfort.byV.Ultra.price) ? ' (' + sg(M.comfort.byV.Ultra.price) + ')' : '';
    });
    /* „Alegi tu” din Specificații */
    $$('#e-plist li.gen').forEach(function (li) { li.remove(); });
    var fli = $('#e-plist li[data-k="fabric"]');
    ROWS.forEach(function (r) {
      if (!M[r.key] || ['bed', 'legs', 'storage', 'x'].indexOf(r.role) < 0 || r.text) return;
      var li = document.createElement('li'); li.className = 'gen'; li.dataset.k = r.key;
      var sub = r.role === 'storage' ? 'cu sau fără' : r.role === 'bed' ? (r.vals[0].label.replace(/ cm$/, '') + ' – ' + r.vals[r.vals.length - 1].label) : r.role === 'legs' ? culori(r.vals.length) : '';
      li.innerHTML = '<div><b>' + esc(rowTitle(r.key)) + '</b><span>' + esc(sub) + '</span></div><p>' + esc(plText(r.key)) + '</p>';
      fli.parentNode.insertBefore(li, fli);
    });
    $$('#e-plist li').forEach(function (li) {
      var k = li.dataset.k;
      if (li.classList.contains('gen')) return;
      if (k === 'fabric' ? !FAB.length : !M[k]) { li.hidden = true; return; }
      li.hidden = false;
      var p = $('[data-e-pl="' + k + '"]', li); if (p) p.textContent = plText(k);
      var r2 = $('[data-e-range2="' + k + '"]', li); if (r2 && rangeTxt(k)) r2.textContent = rangeTxt(k);
      var c2 = $('[data-e-pl2="corner"]', li);
      if (c2 && M.corner) { var all0 = M.corner.vals.every(function (x) { return !x.price; }); c2.textContent = 'stânga / dreapta' + (all0 ? ' · fără cost' : ''); }
    });
    figs();
    renderFabrics();
    buildSteps();
  }

  /* Cifrele mari din Specificații: A, B, C din APO, înălțimea din tabel. */
  function figs() {
    var it = [];
    if (apoOk) ['a', 'b', 'c'].forEach(function (k) { var lb = LB(k); if (M[k] && lb && rangeTxt(k)) it.push([rangeTxt(k), lb[0] + ' · ' + lb[2]]); });
    if (PROF && D.prof && D.prof.total) it.push([D.prof.total, 'înălțimea, cu perne']);
    else if (num(T.total)) {
      var l = T.lbl.total || '';
      it.push([cmN(num(T.total)) + ' cm', /tetier/.test(l) ? 'înălțimea, cu tetierele' + (/ridicat/.test(l) ? ' ridicate' : '') : /pern/.test(l) ? 'înălțimea, cu perne' : 'înălțimea']);
    }
    var box = $('#e-figs'); if (!box) return;
    box.innerHTML = it.map(function (x) { return '<div><b>' + esc(x[0]) + '</b><span>' + esc(x[1]) + '</span></div>'; }).join('');
    box.hidden = !it.length;
    box.style.setProperty('--n', it.length || 1);
  }

  /* ---------- Conținutul din tabel (sau din profilul aprobat) ---------- */
  function ro(s) {
    var R = [[/\bdin brad si fag\b/gi, 'de brad și fag'], [/\bdin brad\b/gi, 'de brad'], [/\bsi\b/g, 'și'], [/\bchinga elastica\b/gi, 'chingă elastică'], [/\bplacaj fag\b/gi, 'placaj de fag'],
      [/\blemn de Fag\b/g, 'lemn de fag'], [/\bde FAG\b/g, 'de fag'], [/\bvopsite in diferite nuante\b/gi, 'vopsit în diferite nuanțe'], [/\bCires\b/g, 'Cireș']];
    s = String(s || '');
    R.forEach(function (r) { s = s.replace(r[0], r[1]); });
    return s;
  }
  function legsMat() {
    var l = norm(T.legs || '');
    if (/fag/.test(l) && /metal|crom/.test(l)) return 'lemn de fag sau metal cromat';
    if (/fag/.test(l)) return 'lemn de fag';
    if (/plastic/.test(l)) return 'plastic dur';
    if (/metal|crom/.test(l)) return 'metal cromat';
    return '';
  }
  function backParts() {
    var b = String(T.backMat || ''); if (!b || /^nu\b/i.test(b.trim())) return null;
    var i = b.search(/ultra/i), std = i >= 0 ? b.slice(0, i) : b, ul = i >= 0 ? b.slice(i) : '';
    if (!mat(ul) && / sau /.test(std)) { var p = std.split(/ sau /); std = p[0]; ul = p.slice(1).join(' sau '); }
    return { std: mat(std), ultra: mat(ul) };
  }
  function mat(x) {
    var n = norm(x); if (!n) return '';
    if (/amestec/.test(n)) return 'un amestec de bumbac sintetic și burete tocat';
    if (/poliuretan/.test(n)) { var d = /(\d+)\s*kg\/m/.exec(n); return 'poliuretan' + (d ? ' de ' + d[1] + ' kg/m³' : ''); }
    if (/burete tocat/.test(n)) return 'burete tocat';
    if (/bumbac sintetic/.test(n)) return 'bumbac sintetic';
    if (/puf siliconizat/.test(n)) return 'puf siliconizat';
    return '';
  }
  function weightTxt() {
    var w = norm(T.weight || ''), m = /maxim\s*(\d+)\s*kg/.exec(w);
    if (m) return { v: 'maximum ' + m[1] + ' kg', s: '' };
    m = /(\d+)\s*-\s*(\d+)\s*kg/.exec(w);
    if (m) return { v: m[1] + '–' + m[2] + ' kg', s: 'după mărime' };
    return null;
  }
  function bedTxt() {
    var b = String(T.bed || ''), xi = b.search(/\bX\b/), ws = [], m, re = /(\d+)\s*cm/g;
    var head = xi >= 0 ? b.slice(0, xi) : '';
    while ((m = re.exec(head))) ws.push(+m[1]);
    var l = /min\.?\s*(\d+)\s*(?:cm)?\s*[,/]?\s*max\.?\s*(\d+)/i.exec(b);
    if (!ws.length || !l) return '';
    var W0 = Math.min.apply(null, ws), W1 = Math.max.apply(null, ws);
    if (W0 === W1) return 'Pat de ' + W0 + ' × ' + l[1] + '–' + l[2] + ' cm, după lungimea aleasă.';
    return 'Pat de ' + l[1] + '–' + l[2] + ' cm lungime și ' + W0 + '–' + W1 + ' cm lățime, după mărimea aleasă.';
  }
  function svText(id, html) {
    var el = $('#' + id); if (!el) return;
    if (html === null) { el.setAttribute('display', 'none'); return; }
    el.removeAttribute('display'); el.innerHTML = html;
  }
  function svHide(id, hide) { var el = $('#' + id); if (el) { if (hide) el.setAttribute('display', 'none'); else el.removeAttribute('display'); } }
  var EXT = false;
  function applyContent() {
    var bp = backParts(), sideShown = false;
    if (PROF) {
      sideShown = true;
      $$('[data-e-prof]').forEach(function (el) { el.hidden = false; });
      $('#e-accSame').hidden = false; $('#e-accMade').hidden = false;
      D.bedText = D.bedTextSet || '';
      $$('[data-e-comfort]').forEach(function (el) { el.textContent = el.getAttribute('data-e-comfort') === 'Ultra' ? (D.comfortUltra || '') : (D.comfortStd || ''); });
    } else {
      $$('[data-e-prof]').forEach(function (el) { el.remove(); });
      /* Desenul din lateral */
      var tot = num(T.total), fr = num(T.frame), ar = NOARMS ? null : num(T.arm), se = num(T.seat), cu = num(T.cushion), bxh = num(T.box), bk = num(T.back);
      var hasBox = /^da/i.test(String(T.hasBox || '').trim());
      if (se && (ar || fr)) {
        sideShown = true;
        var tl = T.lbl.total || '', tet = /tetier/.test(tl);
        svText('e-sv-total', tot ? '<tspan font-weight="700">' + cmN(tot) + ' cm</tspan> total' + (tet ? '<tspan x="244" dy="10.5" font-size="10" fill="#5F5F5F">cu tetierele' + (/ridicat/.test(tl) ? ' ridicate' : '') + '</tspan>' : '') : null);
        if (tot && tet) $('#e-sv-total').setAttribute('y', '31');
        var same1 = fr && ar && fr === ar, headOn = !!(tot && tet && !bp);
        svText('e-sv-frame', fr ? '<tspan font-weight="700">' + cmN(fr) + ' cm</tspan> cadru' + (same1 ? '<tspan x="244" dy="14">și cotieră</tspan>' : '') : null);
        svText('e-sv-arm', ar && !same1 ? '<tspan font-weight="700">' + cmN(ar) + ' cm</tspan> cotieră' : null);
        /* Cotiera cât cadrul: o singură linie și o singură etichetă; liniile punctate fără etichetă nu se desenează. */
        svHide('e-sv-g-arm', same1 || !ar); svHide('e-sv-l-arm', same1 || !ar); svHide('e-sv-l-frame', !fr); svHide('e-sv-l-total', !tot);
        svHide('e-sv-g-head', !headOn); if (headOn) $('#e-sv-l-total').setAttribute('d', 'M55.4 30h182.6');
        svHide('e-sv-g-cushline', !cu); svHide('e-sv-backdim', !bk);
        svText('e-sv-seat', '<tspan font-weight="700">' + cmN(se) + ' cm</tspan> șezut');
        svText('e-sv-cushion', cu ? 'pernă ' + cmN(cu) + ' cm' : null); svHide('e-sv-g-cushion', !cu); svHide('e-sv-seatnote', !!cu || !T.fixSeat);
        var showBox = hasBox && bxh;
        svText('e-sv-box', showBox ? 'ladă ' + cmN(bxh) + ' cm' : null); svHide('e-sv-g-box', !showBox);
        svText('e-sv-back', bk ? 'spătar ' + cmN(bk) + ' cm' : null);
        var lm = legsMat();
        svText('e-sv-legs', T.legsH ? 'picioare ' + cmN(T.legsH) + ' cm' : (lm ? 'picioare<tspan x="244" dy="14">din ' + esc(lm) + '</tspan>' : null));
        svHide('e-sv-g-backpillow', !bp);
        var aria = ['Vedere din lateral:'];
        if (tot) aria.push('înălțimea totală ' + cmN(tot) + ' cm' + (tet ? ', cu tetierele' : '') + ',');
        if (fr) aria.push('cadrul ' + cmN(fr) + ' cm,'); if (ar) aria.push('cotiera ' + cmN(ar) + ' cm,'); aria.push('șezutul la ' + cmN(se) + ' cm,');
        if (cu) aria.push('perna ' + cmN(cu) + ' cm,'); else if (T.fixSeat) aria.push('șezut fix,');
        if (showBox) aria.push('lada ' + cmN(bxh) + ' cm,'); if (bk) aria.push('spătarul ' + cmN(bk) + ' cm,');
        if (T.legsH) aria.push('picioarele ' + cmN(T.legsH) + ' cm');
        $('#e-sideSvg').setAttribute('aria-label', aria.join(' ').replace(/,$/, ''));
      }
      /* Ce e la fel la orice mărime */
      var same = [];
      if (T.backH && bp) {
        var r = /(\d+)\s*-\s*(\d+)\s*cm/.exec(T.backH), one = num(T.backH);
        if (r) same.push(['Pernele de spătar, înălțime', r[1] + '–' + r[2] + ' cm', '', 'pernele de spătar']); else if (one) same.push(['Pernele de spătar, înălțime', cmN(one) + ' cm', '', 'pernele de spătar']);
      }
      if (T.hasBox) {
        var bxc = num(T.boxCorner), lt = [];
        if (hasBox) { if (bxh) lt.push('în canapea, ' + cmN(bxh) + ' cm'); if (bxc) lt.push('în colț, ' + cmN(bxc) + ' cm'); same.push(['Lada de depozitare', lt.length ? lt.join(' și ') : 'da', '', 'lada']); }
        else same.push(['Lada de depozitare', 'nu are', '', 'lada']);
      }
      var lm2 = legsMat();
      if (lm2) same.push(['Picioarele', lm2 + (T.legsH ? ', ' + cmN(T.legsH) + ' cm' : ''), '', 'picioarele']);
      var wt = weightTxt(); if (wt) same.push(['Greutatea produsului', wt.v, wt.s, 'greutatea']);
      if (same.length && T.warranty) { var wn = /(\d+)\s*an/.exec(T.warranty); same.push(['Garanția', wn ? wn[1] + ' ani' : String(D.warranty || '').replace(/^Garanție\s*/i, ''), '', 'garanția']); }
      if (same.length >= 2) {
        $('#e-sameGen').innerHTML = same.map(function (x) { return '<div><dt>' + esc(x[0]) + '</dt><dd>' + esc(x[1]) + (x[2] ? '<small>' + esc(x[2]) + '</small>' : '') + '</dd></div>'; }).join('');
        $('#e-sameGen').hidden = false;
        var ss = $('#e-sameSub'); ss.textContent = same.map(function (x) { return x[3]; }).join(', '); ss.hidden = false;
        $('#e-sameNote').hidden = !sideShown;
        $('#e-accSame').hidden = false;
      } else $('#e-accSame').remove();
      /* Din ce e făcut */
      var made = [], sub = [];
      if (T.frameMat) {
        var toks = T.frameMat.split(',').map(function (x) { return ro(x.trim()); }).filter(Boolean);
        if (toks.length) { var f = toks.join(', '); made.push(['Cadrul', f.charAt(0).toUpperCase() + f.slice(1).replace(/\.$/, '') + '.']); sub.push('cadrul'); }
      }
      if (T.joint && /holz/i.test(T.joint) && /caps/i.test(T.joint)) made.push(['Îmbinarea', 'Cu holzșuruburi și capse, pentru un cadru mai rezistent.']);
      var dens = [], dm, dre = /(\d+)\s*kg\/m/gi; while ((dm = dre.exec(T.seatMat || ''))) dens.push(dm[1]);
      if (dens.length) {
        made.push(['Șezutul', (T.fixSeat ? 'Fix, fără pernă. ' : '') + 'Standard: poliuretan cu densitatea de minimum ' + dens[0] + ' kg/m³, duritate medie.' + (dens[1] ? ' Ultra Confort: poliuretan de ' + dens[1] + ' kg/m³, mai moale.' : '')]);
        sub.push('șezutul');
      }
      if (T.backMat) {
        if (!bp) { made.push(['Pernele de spătar', 'Nu are perne de spătar.']); sub.push('pernele'); }
        else if (bp.std) { made.push(['Pernele de spătar', bp.std.charAt(0).toUpperCase() + bp.std.slice(1) + (bp.ultra ? ' (Standard) sau ' + bp.ultra + ' (Ultra Confort).' : '.')]); sub.push('pernele'); }
      }
      if (made.length >= 2) {
        $('#e-madeGen').innerHTML = made.map(function (x) { return '<div><dt>' + esc(x[0]) + '</dt><dd>' + esc(x[1]) + '</dd></div>'; }).join('');
        $('#e-madeGen').hidden = false;
        var ms = $('#e-madeSub'); ms.textContent = sub.join(', '); ms.hidden = !sub.length;
        $('#e-accMade').hidden = false;
      } else $('#e-accMade').remove();
      /* Confortul */
      $$('[data-e-comfort]').forEach(function (el) {
        var u = el.getAttribute('data-e-comfort') === 'Ultra', m2 = bp && (u ? bp.ultra : bp.std);
        el.textContent = (u ? 'Te afunzi mai mult, pe un șezut mai moale.' : 'Stai mai drept, pe un șezut ferm.') + (m2 ? ' Pernele de spătar au ' + m2 + '.' : '');
      });
      D.bedText = bedTxt() || 'Se desface în pat.';
    }
    var bt = $('#e-bedText'); if (bt) bt.textContent = D.bedText;
    $('#e-side').hidden = !sideShown;
    EXT = /^da/i.test(String(T.ext || '').trim()) && !!D.hasExt;
  }

  /* ---------- Stofele: grupe cu adaosul în lei, filtre, pătrate ---------- */
  var IMG = {};
  function imgOf(n) { if (IMG[n] === undefined) { var f = FABN[n]; IMG[n] = f ? swatchOf(f.id, 200) : ''; } return IMG[n]; }
  function dotBg(n) { var u = imgOf(n); return u ? 'background-image:url(' + u + ')' : ''; }
  function swImg(n) { var u = imgOf(n); return u ? '<img src="' + esc(u) + '" alt="" loading="lazy" decoding="async" onerror="this.remove()">' : ''; }
  function nameList(raw) { return String(raw || '').split(/[,\n]/).map(function (s) { return s.trim(); }).filter(function (n) { return n && FABN[n]; }); }
  function renderFabrics() {
    if (!FAB.length) return;
    var feat = nameList(D.featured);
    /* Toate stofele, pe familii: câte un rând care se trage în lateral (două rânduri de pătrate la familiile mari), cu numele culorii sub pătrat. */
    var rows = FAMS.map(function (g) {
      var k = g.opt === 'std' && !(g.max > 0) ? 'inc' : 'prem' + (g.tags.indexOf('anti-pată') >= 0 ? ' ap' : '');
      var vis = g.items.filter(function (f) { return !f.hidden || f.name === S.fabric; });
      var names = feat.filter(function (n) { return vis.indexOf(FABN[n]) >= 0; });
      vis.forEach(function (f) { if (names.indexOf(f.name) < 0) names.push(f.name); });
      var sub = (g.opt === 'prem' ? 'Premium' + (g.tags.length ? ', ' + g.tags.join(', ') : '') + ' · ' : '') + culori(names.length);
      return { k: k, html: '<div class="fgroup" data-k="' + k + '"><div class="fg-h"><span><b>' + esc(g.fam) + '</b>' + esc(sub) + '</span><em>' + grpPrice(g.min, g.max) + '</em></div><div class="frow' + (names.length > 8 ? ' r2' : '') + '">' +
        names.map(function (n) { var f = FABN[n]; return '<button class="fcell" type="button" data-pick="fabric" data-v="' + esc(n) + '" aria-pressed="' + (S.fabric === n) + '" aria-label="' + esc(n) + ', ' + fabPriceTxt(f) + '"><span class="fsw">' + swImg(n) + '<svg class="i"><use href="#e-i-check"/></svg></span><span class="fn">' + esc(f.rest) + '</span></button>'; }).join('') + '</div></div>' };
    });
    $('#e-fGroups').innerHTML = rows.map(function (r) { return r.html; }).join('');
    fRowScroll();
    applyFilter();
    var ks = rows.map(function (r) { return r.k; });
    var apChip = $('[data-filter="ap"]'); if (apChip) apChip.hidden = !ks.some(function (k) { return / ap$/.test(k); });
    var incChip = $('[data-filter="inc"]'); if (incChip) incChip.hidden = ks.indexOf('inc') < 0;
    var prChip = $('[data-filter="prem"]'); if (prChip) prChip.hidden = !ks.some(function (k) { return k !== 'inc'; });
    var strip = nameList(D.strip);
    if (strip.length < 6) FAMS.forEach(function (g) { if (g.items[0] && strip.indexOf(g.items[0].name) < 0) strip.push(g.items[0].name); });
    $('#e-strip').innerHTML = strip.map(function (n) { var f = FABN[n]; return '<button type="button" data-fabinfo="' + esc(n) + '"><i>' + swImg(n) + '</i><span>' + esc(n) + '</span><small>' + (f.price ? sg(f.price) : 'inclusă') + '</small></button>'; }).join('');
    var std = FAMS.filter(function (g) { return g.opt === 'std'; }), prem = FAMS.filter(function (g) { return g.opt === 'prem'; });
    var sc = 0; std.forEach(function (g) { sc += g.items.length; });
    var pc = 0; prem.forEach(function (g) { pc += g.items.length; });
    var ddS = $('[data-e-fam="std"]'), ddP = $('[data-e-fam="prem"]');
    if (ddS) { if (std.length) ddS.textContent = std.map(function (g) { return g.fam; }).join(', ') + ' · ' + culori(sc); else ddS.parentNode.hidden = true; }
    if (ddP) { if (prem.length) ddP.textContent = prem.map(function (g) { return g.fam + (g.tags.length ? ', ' + g.tags.join(', ') + ',' : '') + ' ' + grpPrice(g.min, g.max).replace('inclusă în preț', 'inclusă'); }).join(' · ') + ' · ' + culori(pc); else ddP.parentNode.hidden = true; }
    $$('[data-e-fabcount]').forEach(function (el) { el.textContent = fabCount(); });
    $$('[data-dot]').forEach(function (i) { var bg = dotBg(i.dataset.dot); if (bg) i.setAttribute('style', bg); });
  }
  /* Poza din pasul Stofa: randarea de studio, recolorată în stofa aleasă (culoare orientativă). Apare doar dacă produsul are
     masca stofei făcută din aceeași poză (D.mask.m, din snippets/smx-pdp-e-masks.liquid); altfel rămâne poza originală.
     Pozele din galerie care au mască (randările de studio: din față, din unghi, desfăcut în pat; la produsele fără randări 360,
     pozele lor de studio) se recolorează și ele, când ajung pe ecran; fotografiile, de exemplu cele din cameră, rămân cum sunt. */
  function fFile(u) { return String(u).split('?')[0].split('/').pop().toLowerCase(); }
  function fMask(u) {
    var f = fFile(u), m = ((D.mask || {}).m || []).filter(function (e) { return String(e.f).toLowerCase() === f; })[0];
    return m ? { u: m.u, lb: m.lb, lh: m.lh, b: m.b, p: D.mask.p } : null;
  }
  var PREV = { url: null, mask: null, prep: null, pp: null, busy: false, want: null, shown: null };
  (function () {
    var rot = (D.images || []).filter(function (x) { return x.k === 'rot'; });
    var pick = rot.filter(function (x) { return +x.a === 45; })[0] || rot.filter(function (x) { return +x.a === 0; })[0] || rot[0];
    if (pick && (PREV.mask = fMask(pick.u))) PREV.url = pick.u;
    // fără randări 360 (paturi, Chesterfield, fotolii...): prima poză de studio care are mască
    else (D.images || []).some(function (x) { return (PREV.mask = fMask(x.u)) && (PREV.url = x.u); });
  })();
  var GAL = { slides: null, t: 0 }, GALU = {};
  function fGal() {
    if (!GAL.slides) {
      GAL.slides = [];
      $$('#e-stage .eg-slide img').forEach(function (im) {
        var x = (D.images || []).filter(function (y) { return fFile(y.u) === fFile(im.getAttribute('src')); })[0], m = x && fMask(x.u);
        if (m) GAL.slides.push({ im: im, x: x, m: m });
      });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (en) { GAL.slides.forEach(function (s) { if (s.im === en.target && (s.vis = en.isIntersecting)) fGalOne(s); }); });
        }, { rootMargin: '300px' });
        GAL.slides.forEach(function (s) { io.observe(s.im); });
      } else GAL.slides.forEach(function (s) { s.vis = true; });
    }
    GAL.slides.forEach(function (s) { if (s.vis) fGalOne(s); });
  }
  function fGalOne(s) {
    var name = S.fabric, f = name && FABN[name], sw = f ? swatchOf(f.id, 200) : '';
    if (!sw || s.has === name || s.busy || s.dead) return;
    s.busy = true;
    // pe desktop galeria e mare: randarea de 1500 px, ca poza să nu iasă mai moale decât originalul
    if (!s.pp) s.pp = window.smxRecolor.prepare(s.im.clientWidth * (window.devicePixelRatio || 1) > 800 ? s.x.z : s.x.u, s.m);
    s.pp.then(function (p) { return window.smxRecolor.copy(p, sw); }).then(function (cv) {
      cv.toBlob(function (b) {
        s.busy = false;
        if (!b) return;
        if (s.blob) URL.revokeObjectURL(s.blob);
        s.blob = GALU[fFile(s.x.z)] = URL.createObjectURL(b); s.has = name;
        s.im.removeAttribute('srcset'); s.im.removeAttribute('sizes'); s.im.src = s.blob;
        if (S.fabric !== name && s.vis) fGalOne(s);
      }, 'image/jpeg', 0.9);
    }, function () { s.busy = false; s.dead = true; });
  }
  function fPrep() {
    return PREV.pp || (PREV.pp = window.smxRecolor.prepare(PREV.url, PREV.mask).then(function (p) { PREV.prep = p; }, function () { PREV.url = null; }));
  }
  /* Produsul umple caseta pozei (b = chenarul lui în poză, din snippet), ca lipită sus să nu plutească în alb (Filip, 26.10). */
  function fFit(el) {
    var b = PREV.mask && PREV.mask.b, box = el && el.parentNode;
    if (!b || !box) return;
    var W = el.width || el.naturalWidth, H = el.height || el.naturalHeight, bw = box.clientWidth, bh = box.clientHeight;
    if (!W || !H || !bw || !bh) return;
    // poza acoperă toată caseta și marginile ei rămân afară: altfel se vede unde se termină umbra de pe podea (colțul din stânga jos)
    var s = Math.max(Math.min(bw / ((b[2] - b[0]) * W), bh / ((b[3] - b[1]) * H)), bw / W, bh / H), w = W * s, h = H * s;
    var x = Math.min(0, Math.max(bw - w, bw / 2 - (b[0] + b[2]) / 2 * w)), y = Math.min(0, Math.max(bh - h, bh / 2 - (b[1] + b[3]) / 2 * h));
    el.style.cssText = 'position:absolute;display:block;max-width:none;width:' + w + 'px;height:' + h + 'px;left:' + x + 'px;top:' + y + 'px';
  }
  window.addEventListener('resize', function () { var e = $('#e-fPrev .fprev-img > *'); if (e) fFit(e); });
  function fOrig(fig) {
    var box = fig.querySelector('.fprev-img'), im = PREV.prep && PREV.prep.im;
    if (!im || S.fabric || box.firstChild === im) return;
    im.style.cssText = 'display:block;width:100%;height:100%;object-fit:contain';
    box.innerHTML = ''; box.appendChild(im);
    setH($('#e-fPrevCap'), 'Alege o culoare și o vezi aici');
    fig.hidden = false;
    fFit(im);
  }
  function fPrev() {
    var fig = $('#e-fPrev');
    if (S.fabric && window.smxRecolor) { clearTimeout(GAL.t); GAL.t = setTimeout(fGal, 300); } // după poza de aici, ca ea să apară întâi
    if (!fig || !PREV.url || !window.smxRecolor) return;
    var cur = fig.querySelector('.fprev-img > *'); if (cur && !cur.style.position) fFit(cur); // desenată cât pasul era strâns
    // omul a început configurarea: poza, masca și paleta se încarcă din timp, iar poza apare în culoarea ei de la deschiderea pasului,
    // ca prima stofă aleasă să nu împingă pătratele sub deget
    if (!S.fabric) { if (S.started || curStep === 'fabric') fPrep().then(function () { fOrig(fig); }); return; }
    PREV.want = S.fabric;
    if (PREV.busy || PREV.shown === S.fabric) return; // update() vine de mai multe ori după un clic: aceeași stofă nu se redesenează
    PREV.busy = true;
    var go = function () {
      var name = PREV.want, f = FABN[name], sw = f ? swatchOf(f.id, 200) : '';
      if (!PREV.prep || !sw) { PREV.busy = false; return; }
      window.smxRecolor.render(PREV.prep, sw, 720).then(function (cv) {
        var box = fig.querySelector('.fprev-img');
        if (cv.parentNode !== box) { box.innerHTML = ''; box.appendChild(cv); } // pe GPU e mereu același canvas
        setH($('#e-fPrevCap'), 'Culoare orientativă: <b>' + esc(name) + '</b>');
        fig.hidden = false; PREV.busy = false; PREV.shown = name;
        fFit(cv);
        if (PREV.want !== name) fPrev();
      }, function () { PREV.busy = false; });
    };
    if (PREV.prep) go();
    else fPrep().then(go);
  }
  /* Rândul stofei alese se derulează până la ea (și când e aleasă din foaia cu toate culorile). */
  function fRowScroll() {
    $$('#e-fGroups .frow').forEach(function (row) {
      var on = row.querySelector('[aria-pressed="true"]');
      if (on && row.clientWidth) row.scrollLeft = Math.max(0, on.offsetLeft - (row.clientWidth - on.offsetWidth) / 2);
    });
  }
  var curFilter = 'all';
  function applyFilter() {
    $$('.chipf').forEach(function (x) { x.setAttribute('aria-pressed', x.dataset.filter === curFilter); });
    $$('.fgroup').forEach(function (gr) { gr.hidden = !(curFilter === 'all' || gr.dataset.k.split(' ').indexOf(curFilter) >= 0); });
  }
  $$('.chipf').forEach(function (c) { c.addEventListener('click', function () { curFilter = c.dataset.filter; applyFilter(); }); });
  function fabAll(mode) {
    return FAMS.map(function (g) {
      var sub = g.opt === 'prem' ? 'Premium' + (g.tags.length ? ', ' + g.tags.join(', ') : '') : '';
      return '<div class="fg-h fall-h"><span><b>' + esc(g.fam) + '</b>' + esc(sub) + '</span><em>' + grpPrice(g.min, g.max) + '</em></div><div class="fall">' +
        g.items.filter(function (f) { return !f.hidden; }).map(function (f) {
          var n = f.name, on = mode === 'sample' ? SAMPLES.indexOf(n) >= 0 : S.fabric === n;
          return '<button class="fcell" type="button" ' + (mode === 'sample' ? 'data-sample="' + esc(n) + '"' : 'data-pick="fabric" data-v="' + esc(n) + '" data-close') + ' aria-pressed="' + on + '" aria-label="' + esc(n) + ', ' + fabPriceTxt(f) + '"><span class="fsw">' + swImg(n) + '<svg class="i"><use href="#e-i-check"/></svg></span><span class="fn">' + esc(f.rest) + '</span></button>';
        }).join('') + '</div>';
    }).join('');
  }
  function fSel() {
    var el = $('#e-fSel');
    if (S.fabric) { setH(el, '<i style="' + dotBg(S.fabric) + '"></i><span>Ai ales: <b>' + esc(S.fabric) + '</b> · ' + fabPriceTxt(FABN[S.fabric]) + '</span>'); setH($('#e-fDet'), '<button class="det t44" type="button" data-fabinfo="' + esc(S.fabric) + '"><svg class="i"><use href="#e-i-info"/></svg>Despre stofă</button>'); }
    else { var n = fabCount(); setH(el, '<span>' + (n ? 'Toate cele ' + culori(n) + ' sunt mai jos, pe familii.' : 'Stofele sunt mai jos, pe familii.') + ' Trage rândul spre stânga ca să vezi mai multe.' + (fabPaid() ? ' Diferența de preț e scrisă la fiecare familie.' : '') + '</span>'); setH($('#e-fDet'), ''); }
    fRowScroll();
    fPrev();
  }

  /* ---------- Rândurile pliate ---------- */
  function stateTxt(k) {
    var v = S[k]; if (v == null) return null;
    if (k === 'fabric') return v;
    var r = M[k]; if (!r) return null;
    if (r.role === 'a' || r.role === 'b' || r.role === 'c') return v + ' cm';
    if (r.role === 'corner') return 'pe ' + v;
    if (r.role === 'comfort') return v === 'Ultra' ? 'Ultra Confort' : 'Standard';
    if (r.text) return v;
    return r.byV[v] ? r.byV[v].label : v;
  }
  function doneCount() { return REQ.filter(function (k) { return S[k] != null; }).length; }
  function complete() { return apoOk && doneCount() === REQ.length; }
  function nextMissing() { for (var i = 0; i < REQ.length; i++) if (S[REQ[i]] == null) return REQ[i]; return null; }
  /* ---------- Pașii: 1 Mărimea · 2 Colțul și confortul · 3 Stofa. Un pas fără opțiuni dispare. ---------- */
  var STEPS = [], curStep = null, visited = {}, advT, sheetFromList = false;
  var CHECK = '<svg class="i"><use href="#e-i-check"/></svg>';
  var NOUN = { coltar: 'colțarul', canapea: 'canapeaua', fotoliu: 'fotoliul', pat: 'patul', taburet: 'taburetul', perna: 'perna' }[KIND] || 'produsul';
  var PART = { corner: ['Colțul', 'Colț'], comfort: ['Confortul', 'Confort'], legs: ['Picioarele', 'Picioare'], storage: ['Lada', 'Ladă'] };
  var lowFirst = function (s) { return s.charAt(0).toLowerCase() + s.slice(1); };
  function roleOfKey(k) { if (k === 'fabric') return 'fabric'; var r = M[k]; return r ? r.role : k; }
  function stepIdOf(k) { var r = roleOfKey(k); return ['a', 'b', 'c', 'bed'].indexOf(r) >= 0 ? 'size' : r === 'fabric' ? 'fabric' : 'opts'; }
  function stepById(id) { for (var i = 0; i < STEPS.length; i++) if (STEPS[i].id === id) return STEPS[i]; return null; }
  function stepName(s) {
    if (s.id === 'size') return ['Mărimea', 'Mărimea', 'Mărimea'];
    if (s.id === 'fabric') return ['Stofa', 'Stofa', 'Stofa'];
    var parts = [], seen = {}, xs = s.keys.filter(function (k) { return roleOfKey(k) === 'x'; });
    s.keys.forEach(function (k) {
      var role = roleOfKey(k), p = PART[role];
      if (role === 'x') { var tt = String(rowTitle(k) || '').trim(); p = (xs.length === 1 && tt) ? [tt, tt.length > 14 ? 'Opțiuni' : tt] : ['Opțiunile', 'Opțiuni']; }
      if (!p || seen[p[0]]) return; seen[p[0]] = 1; parts.push(p);
    });
    if (!parts.length) return ['Opțiunile', 'Opțiuni', 'Opțiuni'];
    /* Numele întreg le spune pe toate („Colțul, confortul și picioarele”); în stepper, primele două, apoi doar primul, dacă nu încape. */
    var full = parts.map(function (p, i) { return i ? lowFirst(p[0]) : p[0]; });
    return [full.length > 1 ? full.slice(0, -1).join(', ') + ' și ' + full[full.length - 1] : full[0], parts[0][1] + (parts[1] ? ' și ' + lowFirst(parts[1][1]) : ''), parts[0][1]];
  }
  function buildSteps() {
    var by = { size: [], opts: [], fabric: [] };
    if (apoOk) ROWS.forEach(function (r) { if (M[r.key]) by[stepIdOf(r.key)].push(r.key); });
    else if (KIND === 'coltar') by = { size: ['a', 'b', 'c'], opts: ['corner', 'comfort'], fabric: ['fabric'] };
    STEPS = [];
    ['size', 'opts', 'fabric'].forEach(function (id) {
      if (!by[id].length) return;
      var s = { id: id, keys: by[id], n: STEPS.length + 1 };
      var nm = apoOk || id !== 'opts' ? stepName(s) : ['Colțul și confortul', 'Colț și confort', 'Colț'];
      s.name = nm[0]; s.short = nm[1]; s.tiny = nm[2]; STEPS.push(s);
    });
    if (curStep && !stepById(curStep)) curStep = null;
  }
  function isReq(k) { return REQ.indexOf(k) >= 0; }
  function stepMiss(s) { return s.keys.filter(function (k) { return isReq(k) && S[k] == null; }); }
  function stepAny(s) { return s.keys.some(function (k) { return S[k] != null; }); }
  function stepDone(s) { return !!s && !stepMiss(s).length && (stepAny(s) || !!visited[s.id]); }
  /* Pașii nu se mai încuie (Filip, 23.10): oricare se deschide oricând, în orice ordine. Alegerile obligatorii contează doar la „Adaugă în coș”. */
  function stepReach() { return true; }
  function firstOpen() { for (var i = 0; i < STEPS.length; i++) if (!stepDone(STEPS[i])) return STEPS[i]; return null; }
  function stepSum(s) {
    if (!stepAny(s)) return '';
    var t = '', price = 0, nb = function (x) { return String(x).replace(/ (lei|cm)\b/g, '\u00a0$1'); };
    s.keys.forEach(function (k) { price += priceOf(k); });
    if (s.id === 'size') {
      var dims = s.keys.filter(function (k) { return ['a', 'b', 'c'].indexOf(roleOfKey(k)) >= 0; });
      if (dims.length) t = dims.map(function (k) { return S[k] != null ? S[k] : '—'; }).join(' × ') + ' cm';
      if (M.bed && S.bed != null) t = (t ? t + ' · ' : '') + M.bed.byV[S.bed].label;
    } else if (s.id === 'fabric') t = S.fabric || '';
    else t = s.keys.filter(function (k) { return S[k] != null; }).map(function (k) {
      var r = M[k], v = S[k];
      if (r.role === 'corner') return 'Colț pe ' + v;
      if (r.role === 'comfort') return v === 'Ultra' ? 'Ultra Confort' : 'Confort Standard';
      if (r.role === 'legs') return 'Picioare ' + stateTxt(k);
      return stateTxt(k);
    }).join(' · ');
    if (price) t += ' · ' + sg(price);
    return t.split(' · ').filter(Boolean).map(function (x) { return '<span class="pp">' + esc(nb(x)) + '</span>'; }).join(' · ');
  }
  function titleTxt() {
    if (STEPS.length === 1) return STEPS[0].id === 'fabric' ? 'Alegi stofa' : 'Alegi ' + lowFirst(STEPS[0].name);
    return 'Alege-ți ' + NOUN + ' în ' + STEPS.length + ' pași';
  }
  /* Butonul care duce la pasul 1 (primul ecran, bara, vizualizatorul) */
  function goTxt(in3d) {
    if (STEPS.length === 1) return STEPS[0].id === 'fabric' ? 'Alege stofa' : 'Alege ' + lowFirst(STEPS[0].name);
    return in3d ? 'Configurează fără 3D, în ' + STEPS.length + ' pași' : 'Configurează-ți ' + NOUN + ' în ' + STEPS.length + ' pași';
  }
  var stepperOl = $('#e-stepper');
  function renderSteps() {
    var N = STEPS.length, last = STEPS[N - 1];
    ['size', 'opts', 'fabric'].forEach(function (id) {
      var el = $('#e-ps-' + id), s = stepById(id);
      if (!s) { el.hidden = true; return; }
      el.hidden = false;
      var on = curStep === id, done = stepDone(s), reach = stepReach(s), sum = stepSum(s);
      el.classList.toggle('on', on); el.classList.toggle('done', done); el.classList.toggle('off', !reach);
      el.classList.toggle('solo', N === 1); el.classList.toggle('one', s.keys.length === 1);
      var hd = $('.pstep-head', el);
      hd.setAttribute('aria-expanded', on); if (reach) hd.removeAttribute('aria-disabled'); else hd.setAttribute('aria-disabled', 'true');
      setH($('.pn', hd), done && !on ? CHECK : String(s.n));
      setT($('.pt b', hd), s.name);
      var req = s.keys.filter(isReq), got = req.filter(function (k) { return S[k] != null; }).length;
      setH($('.psum', hd), on ? '' : sum + (!done && got && req.length > 1 ? (sum ? ' · ' : '') + '<span class="pp miss">' + got + ' din ' + req.length + ' alese</span>' : ''));
      setT($('.pchg', hd), on || !reach ? '' : (sum ? 'Schimbă' : 'Alege'));
      /* „Continuă” merge mereu la pasul următor, ales sau nu; din ultimul pas, la „Configurația ta”. Cu totul ales, din orice pas
         e „Adaugă în coș”: omul care schimbă doar mărimea nu mai trece iar prin pași (Filip, 26.10). */
      var nb = $('.pnext', el), nx = STEPS[s.n] || null, all = complete();
      nb.hidden = false;
      nb.classList.remove('wait');
      if (all) nb.dataset.cart = '1'; else delete nb.dataset.cart;
      setT(nb, all ? (busy ? 'Se adaugă…' : 'Adaugă în coș') : nx ? 'Continuă: ' + lowFirst(nx.name) + ' →' : 'Vezi ce ai ales →');
    });
    stepperOl.hidden = N < 2;
    if (N >= 2) {
      var sh = STEPS.map(function (s) {
        var on = curStep === s.id, done = stepDone(s), reach = stepReach(s);
        return '<li class="' + (on ? 'on' : '') + (done ? ' done' : '') + '"><button type="button" data-step-go="' + s.id + '"' + (reach ? '' : ' aria-disabled="true"') + (on ? ' aria-current="step"' : '') +
          ' aria-label="Pasul ' + s.n + ': ' + esc(s.name) + (done ? ', ales' : '') + '"><span class="pn">' + (done ? CHECK : s.n) + '</span><span class="nm"><span class="full">' + esc(s.name) + '</span><span class="short">' + esc(s.short) + '</span><span class="tiny">' + esc(s.tiny) + '</span></span></button></li>';
      }).join('');
      if (stepperOl.__h !== sh) { setH(stepperOl, sh); fitStepper(); }
    }
    var t4 = $('#e-t4'); if (N && t4.textContent !== titleTxt()) t4.textContent = titleTxt();
    $('#e-summary').hidden = !(N && (complete() || stepDone(last) || S.started));
    /* Rândul de ales acum (cercul cu litera, evidențiat) și dimensiunea evidențiată pe desen */
    var cs = stepById(curStep), nx = cs ? stepMiss(cs)[0] : null;
    $$('.smx-e .opt').forEach(function (o) { o.classList.toggle('open', o.dataset.k === nx); });
    openKey = curStep === 'size' && nx && ['a', 'b', 'c'].indexOf(nx) >= 0 ? nx : null;
  }
  function setT(el, t) { if (el && el.textContent !== t) el.textContent = t; }
  /* Stepper-ul pe un rând: numele întregi, apoi scurte („Colț și confort”), apoi un cuvânt („Colț”), apoi doar pasul activ cu nume.
     Măsurăm fiecare nume: elementele se strâng singure și s-ar tăia cu „…” fără ca lista să depășească. */
  var FIT = ['l1', 'l2', 'l3'], fitW = 0;
  function fitStepper() {
    if (stepperOl.hidden) return;
    var w = stepperOl.clientWidth; if (!w) return;
    fitW = w;
    FIT.forEach(function (c) { stepperOl.classList.remove(c); });
    var nms = $$('.nm', stepperOl);
    var over = function () { return stepperOl.scrollWidth > w + 1 || nms.some(function (n) { return n.offsetParent && n.scrollWidth > n.clientWidth + 1; }); };
    for (var i = 0; i < FIT.length && over(); i++) { if (i) stepperOl.classList.remove(FIT[i - 1]); stepperOl.classList.add(FIT[i]); }
  }
  window.addEventListener('resize', function () { requestAnimationFrame(function () { if (stepperOl.clientWidth !== fitW) fitStepper(); }); });
  /* Derularea: desenul din pasul 1 stă lipit sus (nu și pe ecranele joase, în landscape); rândul ales ajunge sub el. */
  function stickyOff() {
    if (curStep !== 'size' || planCard.hidden || getComputedStyle(planCard).position !== 'sticky') return 12;
    return planCard.getBoundingClientRect().height + 10;
  }
  /* După ce un pas se strânge sau se deschide, conținutul se mută sub deget: un al doilea tap (dublu-tap, nerăbdare) nu alege nimic până se oprește derularea.
     Contează momentul în care degetul a atins ecranul (pointerdown), nu cel în care ajunge click-ul: pe un telefon ocupat, click-ul vine târziu, pe noul conținut. */
  var tapGuard = 0, tapGuardMax = 0, guardAt = -1e9, lastDown = -1e9;
  document.addEventListener('pointerdown', function (e) { lastDown = e.timeStamp; }, true);
  function guardTaps() { var t = performance.now(); guardAt = t; tapGuard = t + 700; tapGuardMax = t + 1800; }
  function guarded(e) { return e.detail > 0 && lastDown > guardAt - 1500 && lastDown < tapGuard; }
  window.addEventListener('scroll', function () { var t = performance.now(); if (t < tapGuard) tapGuard = Math.min(Math.max(tapGuard, t + 250), tapGuardMax); }, { passive: true });
  function scrollToY(y) { window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' }); }
  function scrollToStep(id) { var el = $('#e-ps-' + id); if (el && !el.hidden) scrollToY(el.getBoundingClientRect().top + window.pageYOffset - 10); }
  function scrollToRow(k) {
    var s = stepById(stepIdOf(k)), el = $('#e-opt-' + k);
    if (!s || !el) return;
    if (s.keys[0] === k || s.keys.length === 1) { scrollToStep(s.id); return; }
    scrollToY(el.getBoundingClientRect().top + window.pageYOffset - stickyOff());
  }
  /* „Continuă” din pas: dacă nu e pe ecran (sau e sub bara de jos), îl aducem. */
  function showNext(s) {
    var b = $('#e-ps-' + s.id + ' .pnext'); if (!b || b.hidden) return;
    var r = b.getBoundingClientRect(), vh = window.innerHeight;
    if (r.bottom > vh - 84 || r.top < 0) scrollToY(window.pageYOffset + r.bottom - vh + 96);
  }
  /* Ca evenimentele e_ din smx-pdp-e-gallery.js (e_pick_*, e_pas_N_gata), ca să se poată compara între ele. */
  function clEv(n) { try { if (typeof window.clarity === 'function') window.clarity('event', n); } catch (_) {} }
  function stepOpened(id) { var s = stepById(id); if (s) clEv('e_pas_' + s.n + '_deschis'); }
  function openStep(id, scroll) {
    clearTimeout(advT);
    if (curStep !== id) stepOpened(id);
    curStep = id; visited[id] = true; S.started = true;
    update();
    if (scroll) { guardTaps(); setTimeout(function () { scrollToStep(id); }, 30); }
  }
  /* Rândul k: deschidem pasul lui, apoi derulăm la el. */
  function goRow(k, scroll) {
    var sid = stepIdOf(k);
    if (curStep !== sid) { stepOpened(sid); curStep = sid; visited[sid] = true; update(); }
    if (scroll) setTimeout(function () { scrollToRow(k); }, 30);
  }
  /* Totul e ales: pașii se strâng pe câte un rând și se deschide „Configurația ta”. */
  function finish() {
    clearTimeout(advT); if (STEPS.length > 1) curStep = null; update(); guardTaps();
    /* Pașii strânși (cu rezumatul pe rând) și „Adaugă în coș” pe același ecran, dacă încap; altfel de la „Configurația ta”. */
    setTimeout(function () {
      var su = $('#e-summary'), ops = $('#e-opts'), cb = $('#e-cartBtn'), y0 = window.pageYOffset;
      var top = ops.getBoundingClientRect().top, fits = cb.getBoundingClientRect().bottom - top <= window.innerHeight - 90;
      scrollToY((fits ? top - 10 : su.getBoundingClientRect().top - 12) + y0);
    }, 30);
  }
  function stepContinue(s) {
    var nx = STEPS[s.n];
    if (nx) openStep(nx.id, true); else finish();
  }
  document.addEventListener('click', function (e) {
    var g = e.target.closest && e.target.closest('.smx-e [data-step-go]'); if (g) {
      var s = stepById(g.dataset.stepGo); if (!s || curStep === s.id || guarded(e)) return;
      /* Un pas încă neatins: spunem ce e de ales înainte și ducem omul acolo. */
      if (!stepReach(s)) { var fo = firstOpen(), fm = fo && stepMiss(fo)[0]; if (fm) goMissing('step', fm); else if (fo) openStep(fo.id, true); return; }
      openStep(s.id, true); return;
    }
    var nb = e.target.closest && e.target.closest('.smx-e .pnext'); if (nb) { if (guarded(e)) return; if (nb.dataset.cart) { addToCart(e); return; } var s2 = stepById(nb.dataset.next); if (s2) stepContinue(s2); }
  });
  /* După o alegere din pași: la rândul următor din același pas (600 ms), la „Continuă”, sau, după stofă, la „Configurația ta”. */
  function afterPick(k) {
    clearTimeout(advT);
    if (k === 'fabric' && PREV.url) return; // cu poza recolorată omul încearcă mai multe stofe: pagina nu derulează de la ele
    var s = stepById(stepIdOf(k)); if (!s) return;
    var i = s.keys.indexOf(k), nm = null;
    for (var j = i + 1; j < s.keys.length; j++) if (isReq(s.keys[j]) && S[s.keys[j]] == null) { nm = s.keys[j]; break; }
    if (!nm) nm = stepMiss(s)[0] || null;
    advT = setTimeout(function () {
      if (curStep !== s.id) return;
      if (nm) scrollToRow(nm);
      else if (s === STEPS[STEPS.length - 1] && complete()) finish();
      else showNext(s);
    }, 600);
  }
  /* Mesaj scurt, deasupra barei: se vede oriunde ar fi omul pe pagină. */
  var toastEl = document.createElement('div'), toastT;
  toastEl.className = 'e-toast'; toastEl.setAttribute('role', 'status'); toastEl.setAttribute('aria-live', 'polite');
  (layers || root).appendChild(toastEl);
  function toast(t, ms) { toastEl.textContent = t; toastEl.classList.add('on'); clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('on'); }, ms || 3500); }
  var pend = null;
  function doPick(k, v, inList) {
    var r = M[k], val = (r && (r.role === 'a' || r.role === 'b' || r.role === 'c')) ? +v : v;
    var ok = apoPick(k, val);
    if (ok) touched[k] = true;
    syncFromApo();
    if (!ok) { update(); toast('Nu am putut schimba alegerea. Încearcă din nou.'); return; }
    S.started = true; resetCartBtn();
    if (inList) visited[stepIdOf(k)] = true;
    update(); if (inList) afterPick(k);
  }
  document.addEventListener('click', function (e) {
    var p = e.target.closest && e.target.closest('.smx-e [data-pick]'); if (!p || p.disabled) return;
    var k = p.dataset.pick, v = p.dataset.v;
    if (guarded(e) && p.closest('#e-alege-din-lista')) return;
    if (!apoOk) {
      /* APO încă se încarcă: ținem minte alegerea și o aplicăm când e gata. */
      pend = { k: k, v: v };
      $$('.smx-e [data-pick]').forEach(function (b) { b.classList.toggle('pend', b === p); });
      toast('Se încarcă prețurile… Alegerea ta se aplică imediat ce sunt gata.');
      return;
    }
    /* Din pași (sau dintr-o foaie deschisă din pași) pagina merge mai departe singură; din restul paginii, doar se alege. */
    doPick(k, v, !!p.closest('#e-alege-din-lista') || (!!p.closest('#e-sheet') && sheetFromList));
  });
  /* Opțiunile text (rare): scriem în câmpul APO. */
  document.addEventListener('input', function (e) {
    var t = e.target; if (!t.matches || !t.matches('.smx-e [data-e-text]')) return;
    var r = M[t.dataset.eText]; if (!r) return;
    var ti = textInput(r); if (!ti) return;
    ti.value = t.value;
    ti.dispatchEvent(new Event('input', { bubbles: true })); ti.dispatchEvent(new Event('change', { bubbles: true }));
    S[r.key] = t.value.trim() || null; S.started = true; update();
  });
  $('#e-calcOpen').addEventListener('click', function () { var c = $('#e-calc'); c.classList.toggle('on'); this.setAttribute('aria-expanded', c.classList.contains('on')); });
  $('#e-calcGo').addEventListener('click', function () {
    if (!M.c) return;
    var h = ((+$('#e-hEl').value || 175) + (+$('#e-hEa').value || 170)) / 2, idx = h < 165 ? 0 : h < 175 ? 1 : h < 185 ? 2 : 3;
    var vs = M.c.vals.filter(function (x) { return !x.hidden && x.avail; }); if (!vs.length) return;
    var r = vs[Math.min(idx, vs.length - 1)].v;
    var res = $('#e-calcRes'); res.hidden = false; res.innerHTML = 'La înălțimea voastră vă recomandăm <b>' + r + ' cm</b> adâncime. Am bifat-o deja.';
    var btn = $('[data-pick="c"][data-v="' + r + '"]'); setTimeout(function () { if (btn) btn.click(); }, 700);
  });

  /* ---------- Prețul: același număr sus, sub desen, în configurație, pe buton și în bară ---------- */
  var dT;
  function tick(el) { if (!el) return; el.classList.remove('tick'); void el.offsetWidth; el.classList.add('tick'); setTimeout(function () { el.classList.remove('tick'); }, 600); }
  function priceOf(k) {
    var v = S[k]; if (v == null) return 0;
    if (k === 'fabric') return FABN[v] ? FABN[v].price : 0;
    var x = M[k] && M[k].byV[v]; return x ? x.price : 0;
  }
  var busy = false, busyT;
  function cartLabel(all, tot, miss) {
    if (busy) return 'Se adaugă…';
    if (!apoOk && !REQ.length) return 'Se încarcă opțiunile…';
    if (all) return 'Adaugă în coș · ' + lei(tot);
    return 'Mai alege: ' + (miss.length <= 3 ? miss.join(', ') : miss.slice(0, 2).join(', ') + ' și încă ' + (miss.length - 2));
  }
  function sumLabel(k) {
    var r = M[k]; if (!r) return '';
    var lb = LB(r.role); if (lb && lb[0]) return lb[0] + ' · ' + lb[1];
    if (r.role === 'storage') return 'Lada';
    return rowTitle(k);
  }
  function sumZero(r) { return (r.role === 'a' || r.role === 'b' || r.role === 'c' || r.role === 'bed' || r.role === 'fabric') ? 'inclusă' : (r.role === 'corner' || r.role === 'legs') ? 'fără cost' : 'inclus'; }
  function basePart() {
    if (LAY === 'L') return ' (' + defDim('a') + ' × ' + defDim('b') + ' cm)';
    if (LAY === 'rect') { var i = inclMax('a'); return i ? ' (' + i + ' cm)' : ''; }
    if (LAY === 'bed') return ' (' + bedDef().label + ')';
    return '';
  }
  function waParts() {
    var p = [];
    if (LAY === 'L') { if (S.a && S.b) p.push(S.a + ' × ' + S.b + ' cm'); else if (S.a) p.push('partea lungă ' + S.a + ' cm'); else if (S.b) p.push('partea scurtă ' + S.b + ' cm'); if (S.c) p.push('adâncime ' + S.c + ' cm'); if (S.corner) p.push('colț pe ' + S.corner); }
    else { if (S.a) p.push((FOT ? 'lățime ' : 'lungime ') + S.a + ' cm'); if (S.c) p.push('adâncime ' + S.c + ' cm'); if (S.corner) p.push('colț pe ' + S.corner); }
    ROWS.forEach(function (r) {
      var v = S[r.key]; if (v == null || !M[r.key]) return;
      if (r.role === 'bed') p.push('mărimea ' + M.bed.byV[v].label);
      else if (r.role === 'storage') p.push(v === 'Da' ? 'cu ladă' : v === 'Nu' ? 'fără ladă' : stateTxt(r.key));
      else if (r.role === 'comfort') p.push('confort ' + (v === 'Ultra' ? 'Ultra Confort' : 'Standard'));
      else if (r.role === 'legs') p.push('picioare ' + stateTxt(r.key));
      else if (r.role === 'x') p.push(r.title + ': ' + stateTxt(r.key));
    });
    if (S.fabric) p.push('stofa ' + S.fabric);
    return p;
  }
  function update() {
    if (D.noApo) return;
    var tot = total(), all = complete(), from = fromPrice();
    $('#e-heroPrice').textContent = lei(all ? tot : from);
    $('#e-fromLbl').firstChild.nodeValue = all ? 'Total ' : 'de la ';
    setOld($('#e-oldPrice'), all ? tot : from);
    $$('.smx-e .opt').forEach(function (o) {
      var k = o.dataset.k, t = stateTxt(k), st = $('.opt-state', o);
      o.classList.toggle('done', t !== null);
      setH(st, t !== null ? ('<svg class="i ck"><use href="#e-i-check"/></svg><b>' + esc(t) + '</b>') : '');
    });
    $$('.smx-e [data-pick]').forEach(function (b) { var k = b.dataset.pick, on = String(S[k] != null && String(S[k]) === b.dataset.v); if (b.getAttribute('aria-pressed') !== on) b.setAttribute('aria-pressed', on); });
    var roL = $('#e-roLbl'), roS = $('#e-roSize');
    if (LAY === 'L') {
      var dims = S.a || S.b || S.c;
      roL.textContent = dims ? 'Mărimea ta (A × B × C)' : 'Inclus în prețul de bază';
      roS.textContent = dims ? ((S.a || '—') + ' × ' + (S.b || '—') + ' × ' + (S.c || '—') + ' cm') : (apoOk && M.a && M.b ? 'până la ' + defDim('a') + ' × ' + defDim('b') + ' cm' : '');
    } else if (LAY === 'rect') {
      var d2 = S.a || S.c, im = inclMax('a');
      roL.textContent = !d2 ? 'Inclus în prețul de bază' : (S.a && S.c) ? 'Mărimea ta (A × B)' : S.a ? (FOT ? 'Lățimea ta' : 'Lungimea ta') + (M.c ? ' · adâncimea de ales' : '') : 'Adâncimea ta · ' + (FOT ? 'lățimea' : 'lungimea') + ' de ales';
      roS.textContent = !d2 ? (im ? 'până la ' + im + ' cm' : '') : (S.a && S.c) ? (S.a + ' × ' + S.c + ' cm') : ((S.a || S.c) + ' cm');
    } else if (LAY === 'bed') {
      roL.textContent = S.bed ? 'Mărimea patului' : 'Inclus în prețul de bază';
      roS.textContent = S.bed ? M.bed.byV[S.bed].label : bedDef().label;
    }
    $('#e-roPrice').textContent = lei(tot);
    setOld($('#e-roOld'), tot);
    if (tot !== lastTot) {
      var d = tot - lastTot, de = $('#e-delta'), bd = $('#e-barDelta');
      de.textContent = bd.textContent = (d > 0 ? '+' : '−') + lei(Math.abs(d)); de.classList.add('on'); bd.classList.add('on');
      clearTimeout(dT); dT = setTimeout(function () { de.classList.remove('on'); bd.classList.remove('on'); }, 1600);
      tick($('#e-roPrice')); tick($('#e-barMid')); tick($('#e-barTot')); lastTot = tot;
    }
    /* Configurația ta */
    var rows = [['Prețul de bază' + (apoOk ? basePart() : ''), [null, lei(BASE)]]];
    ROWS.forEach(function (r) {
      if (!M[r.key]) return;
      var t = stateTxt(r.key);
      if (r.role === 'comfort' && t) t = S.comfort === 'Ultra' ? 'Ultra' : 'Standard';
      rows.push([esc(r.role === 'fabric' ? 'Stofa' : sumLabel(r.key)), t !== null ? [t, plus(priceOf(r.key)) || sumZero(r)] : null]);
    });
    setH($('#e-sumList'), rows.map(function (r) {
      var d = r[1]; if (!d) return '<div><dt>' + r[0] + '</dt><dd class="empty">de ales</dd></div>';
      var pz = d[1].indexOf('lei') < 0;
      return '<div><dt>' + r[0] + '</dt><dd>' + (d[0] ? '<span class="v">' + esc(d[0]) + '</span><span class="s">·</span>' : '') + '<span class="p' + (pz ? ' z' : '') + '">' + d[1] + '</span></dd></div>';
    }).join(''));
    $('#e-totLbl').textContent = all ? 'Total' : 'Total până acum';
    $('#e-totPrice').textContent = lei(tot);
    setOld($('#e-totOld'), tot);
    var miss = REQ.filter(function (k) { return S[k] == null; }).map(missOf);
    $('#e-cartTxt').textContent = cartLabel(all, tot, miss);
    $('#e-barCart').textContent = busy ? 'Se adaugă…' : 'Adaugă în coș';
    $('#e-cartBtn').setAttribute('aria-disabled', !all);
    var mi = $('#e-missing');
    if (!mi.classList.contains('err')) mi.textContent = all ? '' : (!apoOk ? 'Se încarcă opțiunile…' : (doneCount() ? 'Mai ai de ales: ' + miss.join(', ') + '.' : (REQ.length === 1 ? 'Alege ' + missOf(REQ[0]) + ' de mai sus și butonul se aprinde.' : 'Alege cele ' + REQ.length + ' opțiuni de mai sus și butonul se aprinde.')));
    var parts = waParts();
    var conf = 'Bună ziua! Aș vrea să comand ' + (D.title || SHORT) + (parts.length ? ': ' + parts.join(', ') : '') + '. Total ' + lei(tot) + '.\nProdus: ' + (D.url || location.href.split('?')[0]);
    $('#e-waCfg').href = waLink(conf);
    $('#e-barWa').href = waLink('Bună ziua! Am o întrebare.\nProdus: ' + (D.title || SHORT) + '\n' + (D.url || ''));
    renderSteps();
    var bsS = stepById(curStep) || firstOpen() || STEPS[STEPS.length - 1];
    $('#e-barStep').textContent = !STEPS.length ? 'Se încarcă…' : STEPS.length === 1 ? STEPS[0].name : 'Pasul ' + bsS.n + ' din ' + STEPS.length;
    $('#e-barMid').textContent = lei(tot);
    setOld($('#e-barMidOld'), tot);
    $('#e-barTot').textContent = lei(tot);
    setOld($('#e-barOld'), tot);
    $('#e-barFrom').textContent = lei(from);
    fSel();
    setBar();
    drawPlans();
    measureSoon();
  }

  /* ---------- „Adaugă în coș”: butonul APO face restul (Cart Transform, apoi coșul temei) ---------- */
  function resetCartBtn() {
    busy = false; clearTimeout(busyT); clearErrT();
    var cb = $('#e-cartBtn'); cb.removeAttribute('aria-busy');
    var mi = $('#e-missing'); if (mi.classList.contains('err')) { mi.classList.remove('err'); mi.textContent = ''; }
  }
  /* Prima alegere lipsă: deschidem pasul ei, derulăm la ea și o evidențiem (din coș sau din „Continuă”). */
  function goMissing(from, key) {
    var n = key || nextMissing(); if (!n) return;
    goRow(n, true);
    if (!from) return;
    var miss = REQ.filter(function (k) { return S[k] == null; });
    if (from === true) toast(miss.length <= 1 ? 'Mai ai de ales ' + missOf(n) + ', apoi poți adăuga în coș.' : 'Mai ai ' + miss.length + ' alegeri. Începe cu ' + missOf(n) + '.', 4000);
    else toast('Alege mai întâi ' + missOf(n) + '.', 3000);
    var s = stepById(stepIdOf(n)), h = s && s.keys.length === 1 ? $('#e-ps-' + s.id) : $('#e-opt-' + n);
    if (!h) return;
    h.classList.remove('need'); void h.offsetWidth; h.classList.add('need');
    setTimeout(function () { h.classList.remove('need'); }, 2600);
  }
  /* Ce cere APO sau poarta temei și nu e ales (aceeași regulă ca în smx-cro-mobile-fixes). */
  function apoMissing() {
    var out = [], sel = selNow(), fabSeen = false, fabHas = false;
    try {
      (ap.getState().options || []).forEach(function (o) {
        if (o.hidden) return;
        var t = norm(o.title), ids = o.valueIds || getVals(o).map(function (v) { return v.id; });
        var has = ids.some(function (id) { return sel.indexOf(id) >= 0; });
        if (FABRIC_RE.test(t)) { fabSeen = true; if (has) fabHas = true; return; }
        if (has || !ids.length) return;
        if (o.required || PSEUDO_RE.test(t)) out.push(o);
      });
    } catch (err) {}
    if (fabSeen && !fabHas) out.push({ fabric: true, id: '' });
    return out;
  }
  function rowOfOpt(id) { for (var i = 0; i < ROWS.length; i++) { if (ROWS[i].copies && ROWS[i].copies.some(function (o) { return o.id === id; })) return ROWS[i]; } return null; }
  var errT = [];
  function clearErrT() { errT.forEach(clearTimeout); errT = []; }
  /* După click pe butonul APO: dacă APO arată un mesaj de opțiune lipsă, îl spunem aici pe loc (nu după 12 s). */
  function watchApoErr() {
    clearErrT();
    [300, 800, 1500].forEach(function (ms) {
      errT.push(setTimeout(function () {
        if (!busy) return;
        var errs = $$('.e-apo .mw-option__helptext.mw-text--style-negative:not(.mw-hidden)');
        if (!errs.length) return;
        var names = [], firstKey = null;
        errs.forEach(function (el) {
          var op = el.closest('.mw-option'), id = op && op.getAttribute('data-option-id'), r = id ? rowOfOpt(id) : null;
          var nm = r && M[r.key] ? missOf(r.key) : (FABRIC_RE.test(norm(op && op.getAttribute('data-smx-name'))) ? 'stofa' : norm(op && op.getAttribute('data-smx-name')));
          if (nm && names.indexOf(nm) < 0) names.push(nm);
          if (!firstKey && r && M[r.key]) firstKey = r.key;
        });
        busy = false; clearTimeout(busyT); clearErrT(); $('#e-cartBtn').removeAttribute('aria-busy');
        var mi = $('#e-missing'); mi.classList.add('err'); mi.textContent = 'Mai ai de ales: ' + names.join(', ') + '.';
        update();
        if (firstKey) goRow(firstKey, true);
      }, ms));
    });
  }
  function addToCart(e) {
    e.preventDefault();
    if (busy) return;
    /* Tap pe coș imediat după ultima stofă: pașii nu se mai strâng sub deget. */
    clearTimeout(advT);
    if (!complete()) { if (apoOk) goMissing(true); else toast('Se încarcă opțiunile… Încearcă din nou în câteva secunde.'); return; }
    var lack = apoMissing();
    if (lack.length) {
      var o = lack[0], r = o.fabric ? M.fabric : rowOfOpt(o.id);
      if (r && M[r.key]) goMissing(true, r.key);
      else toast('Mai e de ales: ' + (o.fabric ? 'stofa' : domTitle(o)) + '.', 4000);
      return;
    }
    var btn = apoBox && apoBox.querySelector('.mw-apo-add-to-cart-custom');
    if (!btn) { var m0 = $('#e-missing'); m0.classList.add('err'); m0.textContent = 'Coșul nu e gata încă. Mai încearcă o dată în câteva secunde.'; return; }
    busy = true; $('#e-cartBtn').setAttribute('aria-busy', 'true'); update();
    /* Înapoi din coș reîncarcă pagina: ținem minte alegerile, ca să le punem la loc. */
    try { sessionStorage.setItem(SELKEY, JSON.stringify({ t: Date.now(), ids: ap.getSelections() || [] })); } catch (_) {}
    btn.click();
    watchApoErr();
    clearTimeout(busyT);
    busyT = setTimeout(function () {
      busy = false; $('#e-cartBtn').removeAttribute('aria-busy');
      var mi = $('#e-missing'); mi.classList.add('err');
      mi.textContent = 'Nu s-a putut adăuga în coș. Încearcă din nou sau scrie-ne pe WhatsApp.';
      update();
    }, 12000);
  }
  $('#e-cartBtn').addEventListener('click', addToCart);
  $('#e-barCart').addEventListener('click', addToCart);
  /* „Continuă” din bară: pasul următor sau, dacă pasul deschis nu e gata, prima alegere lipsă din el. */
  $('#e-barNext').addEventListener('click', function () {
    var s = stepById(curStep);
    if (s) { stepContinue(s); return; }
    var n = nextMissing(); if (n) goMissing('step', n); else if (STEPS.length) finish();
  });
  window.addEventListener('pageshow', function () { if (busy) { resetCartBtn(); update(); } closeAll(); });

  /* ---------- Bara fixă de jos: ascunsă cât butonul principal e pe ecran ---------- */
  var heroVisible = true, cartVisible = false, overlayOpen = false;
  function setBar() {
    var bar = $('#e-bar'), st = complete() ? 'c' : ((doneCount() > 0 || S.started) ? 'b' : 'a'); bar.dataset.state = st;
    var show = !D.noApo && !overlayOpen && !heroVisible && !(st === 'c' && cartVisible);
    bar.classList.toggle('show', show);
    html.classList.toggle('e-bar-on', show);
    /* Fără 3D, butonul din bară spune ce alegi; dacă textul nu încape, rămâne „Alege din listă”. */
    var go = $('#e-barGo');
    if (show && st === 'a' && go && !go.__fit) { go.__fit = true; (go.__alts || ['Configurează']).forEach(function (a) { if (go.scrollWidth > go.clientWidth + 1) go.textContent = a; }); }
    /* Prețul tăiat din bară se ascunde când nu încape lângă prețul final (totaluri de 5 cifre pe ecrane înguste). */
    if (show) Array.prototype.forEach.call(bar.querySelectorAll('.bt'), function (bt) {
      var s = bt.querySelector('s'), k = st + '|' + bt.textContent + '|' + window.innerWidth;
      if (!s || bt.__k === k || !bt.offsetParent) return;
      bt.__k = k; s.style.display = ''; if (bt.scrollWidth > bt.clientWidth + 1) s.style.display = 'none';
    });
  }
  /* Vizibilitatea se măsoară direct (la derulare, cu rAF), nu din intrările observatorului, care pot veni în lot și vechi. */
  var heroEl = $('#e-cta3d') || $('#e-toList') || $('#e-askPrice'), cartEl = $('#e-cartBtn'), measQ = false;
  function measure() {
    measQ = false;
    if (!heroEl || !cartEl) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var r = heroEl.getBoundingClientRect(), c = cartEl.getBoundingClientRect();
    heroVisible = r.height > 0 && r.bottom > 64 && r.top < vh;
    cartVisible = c.height > 0 && (Math.min(c.bottom, vh) - Math.max(c.top, 0)) >= c.height * 0.5;
    /* „Continuă” din pas e pe ecran: cel din bară devine secundar, ca să nu fie două butoane portocalii. */
    var pn = curStep && $('#e-ps-' + curStep + ' .pnext'), calm = false;
    if (pn && !pn.hidden && !pn.classList.contains('wait')) { var q = pn.getBoundingClientRect(); calm = q.height > 0 && q.top < vh - 72 && q.bottom > 0; }
    $('#e-bar').classList.toggle('calm', calm);
    setBar();
  }
  function measureSoon() { if (!measQ) { measQ = true; requestAnimationFrame(measure); } }
  window.addEventListener('scroll', measureSoon, { passive: true });
  window.addEventListener('resize', measureSoon);
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(measureSoon, { rootMargin: '-64px 0px 0px 0px', threshold: [0, 0.01, 0.5, 1] });
    io.observe(heroEl); io.observe(cartEl);
  }
  measureSoon();

  /* ---------- Poza: camera → rot_000 → rot_045 ---------- */
  function loadSrc(imgs) { imgs.forEach(function (i) { if (i && i.dataset.src) { if (i.dataset.srcset) { i.srcset = i.dataset.srcset; i.removeAttribute('data-srcset'); } i.src = i.dataset.src; i.removeAttribute('data-src'); } }); }
  function rotator(box, imgs, opt) {
    var idx = 0, sx = 0, sy = 0, lx = 0, t0 = 0, down = false, dec = false, steps = 0;
    function show(n) { imgs[idx].classList.remove('on'); idx = n; imgs[idx].classList.add('on'); steps++; if (opt.onFrame) opt.onFrame(idx, steps); }
    function step(dir) {
      var n = idx + dir;
      if (n < 0 || n >= imgs.length) { box.style.setProperty('--bx', (dir > 0 ? -12 : 12) + 'px'); box.classList.remove('bump'); void box.offsetWidth; box.classList.add('bump'); return; }
      show(n);
    }
    box.addEventListener('pointerdown', function (e) { if (e.target.closest('.chip,.pill,.shown')) return; loadSrc(imgs); down = true; dec = false; sx = lx = e.clientX; sy = e.clientY; t0 = Date.now(); });
    box.addEventListener('pointermove', function (e) {
      if (!down) return; var dx = e.clientX - sx, dy = e.clientY - sy;
      if (!dec) { if (Math.abs(dx) > 10 && Math.abs(dx) > 1.5 * Math.abs(dy)) { dec = true; try { box.setPointerCapture(e.pointerId); } catch (_) {} } else if (Math.abs(dy) > 10) { down = false; } return; }
      var d = e.clientX - lx; while (Math.abs(d) >= 40) { step(d < 0 ? 1 : -1); lx += d < 0 ? -40 : 40; d = e.clientX - lx; }
    });
    box.addEventListener('pointerup', function (e) { if (!down) return; down = false; if (!dec && Math.hypot(e.clientX - sx, e.clientY - sy) < 10 && Date.now() - t0 < 300 && opt.onTap) opt.onTap(); });
    box.addEventListener('pointercancel', function () { down = false; });
    return { show: function (n) { loadSrc(imgs); if (n !== idx) show(n); } };
  }
  var pill = $('#e-pill'), stage = $('#e-stage'), turned = false, frames = $$('.fr', stage);
  function pillGo() {
    if (turned || !pill) return; turned = true;
    if (!D.cfg) { pill.hidden = true; return; }
    pill.classList.add('go'); pill.innerHTML = '<svg class="i"><use href="#e-i-cube"/></svg><span>Vezi-l din toate unghiurile, în 3D ›</span>'; pill.setAttribute('data-3d', 'poza');
  }
  var rot = rotator(stage, frames, { onFrame: function (i) { $('#e-prog').style.width = (frames.length > 1 ? i / (frames.length - 1) * 100 : 0) + '%'; var sc = $('#e-shownChip'); if (sc) sc.hidden = i > 0; $('#e-rndChip').hidden = !(i > 0); if (i > 0) pillGo(); }, onTap: function () { openViewer(frames.length > 1 ? 'rot' : 'poze'); } });
  if (pill) pill.addEventListener('click', function (e) { if (turned) return; e.preventDefault(); e.stopPropagation(); rot.show(1); setTimeout(function () { rot.show(2); }, 650); });
  window.addEventListener('load', function () { var go = function () { loadSrc(frames); }; if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 3000 }); else setTimeout(go, 1500); });

  /* ---------- Vizualizatorul: Rotește / Ca pat / Poze ---------- */
  var IM = D.images || [];
  var rooms = IM.filter(function (x) { return x.k === 'room'; });
  var studio = IM.filter(function (x) { return x.k === 'rot'; }).sort(function (p, q) { return (+p.a) - (+q.a); });
  var ext = IM.filter(function (x) { return x.k === 'ext'; })[0];
  var s0 = studio.filter(function (x) { return x.a === '000'; })[0], s45 = studio.filter(function (x) { return x.a === '045'; })[0];
  var photos = rooms.concat([s0, s45, ext].filter(Boolean));
  if (!photos.length) photos = IM.slice();
  var pc = $('[data-e-photos]'); if (pc) pc.textContent = photos.length;
  if (photos.length < 2 && $('#e-photosChip')) $('#e-photosChip').hidden = true;
  function shownChip() { return D.photoFabric ? '<button class="shown t44" type="button" data-fabinfo="' + esc(D.photoFabric) + '"><i style="' + dotBg(D.photoFabric) + '"></i>În poză: <b>' + esc(D.photoFabric) + '</b></button>' : ''; }
  var rndChip = '<span class="shown rnd">Randare 3D</span>';
  function vbody(t) {
    var nm = esc(SHORT);
    if (t === 'rot') return '<div class="vrot" id="e-vrot">' + studio.map(function (x, i) { return '<img' + (i === 0 ? ' class="on"' : ' loading="lazy"') + ' src="' + esc(x.z) + '" alt="' + nm + ', ' + (+x.a) + ' de grade" draggable="false" width="' + x.w + '" height="' + x.h + '">'; }).join('') + '</div><p class="vcap">Glisează stânga-dreapta ca să-l rotești.</p>';
    if (t === 'pat') return ext ? '<img src="' + esc(ext.z) + '" alt="' + nm + ' desfăcut în pat" style="width:100%;height:auto" width="' + ext.w + '" height="' + ext.h + '"><p class="vcap">' + esc(D.bedText || '') + '</p>' : '';
    return '<div class="vlist">' + photos.map(function (x, i) { return '<figure><img src="' + esc(GALU[fFile(x.z)] || x.z) + '" alt="' + nm + (x.k === 'room' ? ' în cameră' : x.k === 'ext' ? ' desfăcut în pat, randare' : ', randare') + '"' + (i ? ' loading="lazy"' : '') + ' width="' + x.w + '" height="' + x.h + '">' + (x.k === 'room' ? shownChip() : rndChip) + '</figure>'; }).join('') + '</div>' + (D.photoFabric ? '<p class="vcap">Apasă pe numele stofei ca s-o vezi de aproape.</p>' : '');
  }
  function vtab(t) {
    if (!$('.vtabs [data-v="' + t + '"]')) t = 'poze';
    $$('.vtabs button').forEach(function (b) { b.setAttribute('aria-selected', b.dataset.v === t); });
    var vb = $('#e-vbody'); vb.innerHTML = vbody(t); vb.classList.toggle('mid', t !== 'poze'); vb.scrollTop = 0;
    if (t === 'rot') { var box = $('#e-vrot'); rotator(box, $$('img', box), {}); }
  }
  function openViewer(t) { overlayOpen = true; setBar(); $('#e-viewer').classList.add('on'); vtab(t || 'rot'); try { history.pushState({ eVw: 1 }, ''); } catch (_) {} }
  function closeViewer() { if (!$('#e-viewer').classList.contains('on')) return; if (history.state && history.state.eVw) { history.back(); return; } $('#e-viewer').classList.remove('on'); overlayOpen = curSheet !== null || $('#e-loading').classList.contains('on'); setBar(); }
  $$('.vtabs button').forEach(function (b) { b.addEventListener('click', function () { vtab(b.dataset.v); }); });
  document.addEventListener('click', function (e) { var b = e.target.closest && e.target.closest('.smx-e [data-viewer]'); if (b) { e.preventDefault(); e.stopPropagation(); openViewer(b.dataset.viewer); } }, true);
  $('#e-vX').addEventListener('click', function () { if (history.state && history.state.eVw) history.back(); else closeViewer(); });
  window.addEventListener('popstate', function () { if ($('#e-viewer').classList.contains('on')) { $('#e-viewer').classList.remove('on'); overlayOpen = curSheet !== null; setBar(); } });

  /* ---------- Intrările în 3D: stratul „Se deschide … în 3D”, apoi pagina configuratorului ---------- */
  var slowT;
  function analyticsOk() { var cp = window.Shopify && window.Shopify.customerPrivacy; return !(cp && typeof cp.analyticsProcessingAllowed === 'function' && !cp.analyticsProcessingAllowed()); }
  function open3d(el) {
    var href = (el.tagName === 'A' && el.href) || D.cfg; if (!href) return;
    var from = 'e-' + String(el.getAttribute('data-3d') || '').replace(/_/g, '-');
    if (el.tagName !== 'A') {
      /* Linkurile <a data-smx-from> le notează scriptul temei; butoanele (pastila) le notăm aici, la fel. */
      try { sessionStorage.setItem('smx_cfg_from', from); } catch (_) {}
      try { if (analyticsOk() && typeof window.clarity === 'function') window.clarity('event', 'pdp_cfg_' + from.replace(/-/g, '_')); } catch (_) {}
    }
    var poster = $('#e-poster');
    try {
      sessionStorage.setItem('smx_cfg_poster', (poster && (poster.dataset.src || poster.src)) || '');
      sessionStorage.setItem('smx_cfg_title', SHORT);
      sessionStorage.setItem('smx_cfg_back', location.href.split('#')[0]);
      sessionStorage.setItem('smx_cfg_src', new URL(href, location.href).searchParams.get('source') || '');
    } catch (_) {}
    closeAll(true);
    overlayOpen = true; setBar(); loadSrc([poster]);
    $('#e-loading').classList.add('on'); $('#e-slow').innerHTML = '';
    clearTimeout(slowT); slowT = setTimeout(function () { $('#e-slow').innerHTML = 'Durează mai mult decât de obicei.<br><button class="lnk" type="button" data-close data-tolist>Configurează fără 3D ›</button>'; }, 12000);
    requestAnimationFrame(function () { requestAnimationFrame(function () { location.href = href; }); });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.smx-e [data-3d]'); if (!a) return;
    if (a.id === 'e-pill' && !turned) return;
    if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault(); open3d(a);
  });
  var cube = $('#e-cube'); if (cube) setTimeout(function () { cube.classList.add('spin'); }, 1000);

  /* ---------- Foile ---------- */
  var clone = function (ids) { return '<ul class="rows">' + ids.map(function (id) { var el = $('#' + id); return el ? el.outerHTML.replace(/ id="[^"]+"/, '') : ''; }).join('') + '</ul><a class="lnk" href="#e-livrare" data-close>Tot despre livrare, plată și retur ›</a>'; };
  function orientFig(right) {
    var L = right ? 'M300 30H58V82H218V150H300Z' : 'M58 30H300V82H140V150H58Z';
    return '<svg viewBox="0 0 358 214" aria-hidden="true" font-family="Inter, system-ui, sans-serif"><path d="' + L + '" fill="#EDE7E0" stroke="#1E1A17" stroke-width="2" stroke-linejoin="round"/>' +
      '<path d="' + (right ? 'M218 150H300' : 'M58 150H140') + '" stroke="#D93006" stroke-width="5" stroke-linecap="round"/>' +
      '<text x="179" y="20" text-anchor="middle" font-size="12" fill="#5F5F5F">spătarul, lângă perete</text>' +
      '<text x="' + (right ? 259 : 99) + '" y="172" text-anchor="middle" font-size="13" font-weight="700" fill="#B52805">partea scurtă</text>' +
      '<circle cx="179" cy="186" r="6" fill="#1E1A17"/><path d="M167 212c2-8 6-12 12-12s10 4 12 12" fill="#1E1A17"/>' +
      '<path d="M179 176v-58M173 124l6-8 6 8" stroke="#1E1A17" stroke-width="1.5" fill="none"/>' +
      '<text x="' + (right ? 165 : 193) + '" y="150" text-anchor="' + (right ? 'end' : 'start') + '" font-size="12" fill="#5F5F5F">tu, în fața lui</text></svg>';
  }
  function pretText() {
    if (!apoOk) return HAS3D ? '<p>Prețul „de la” e pentru mărimea de bază, cu stofă și confort Standard. Prețul exact îl vezi pe loc, în 3D sau aici, pe pagină.</p>'
      : '<p>Prețul „de la” e pentru varianta de bază, cu stofă Standard. Prețul exact îl vezi pe loc, când alegi.</p>';
    var parts = [];
    if (LAY === 'L') parts.push('mărimea de până la ' + defDim('a') + ' × ' + defDim('b') + ' cm');
    else if (LAY === 'rect') parts.push((FOT ? 'lățimea' : 'lungimea') + ' de până la ' + (inclMax('a') || defDim('a')) + ' cm');
    else if (LAY === 'bed') parts.push('mărimea ' + bedDef().label);
    if (M.c) parts.push('adâncime ' + defDim('c') + ' cm');
    var t = HAS3D ? '<p>Prețul „de la” (' + lei(BASE) + ') e pentru ' + (parts.join(', ') || 'varianta de bază') + ', cu stofă și confort Standard.'
      : '<p>Prețul „de la” (' + lei(BASE) + ') e pentru ' + (parts.length ? parts.join(', ') + ', ' : 'varianta de bază, ') + 'cu stofă Standard' + (M.comfort ? ' și confort Standard' : '') + '.';
    var sa = stepTxt('a'), sb = stepTxt('b');
    if (LAY === 'L' && sa && sa === sb && /^Apoi \+/.test(sa)) t += ' Fiecare ' + sa.replace(/^Apoi \+[^ ]+ lei la fiecare /, '').replace(/\.$/, '') + ' în plus, pe oricare latură, costă ' + sa.match(/\+([\d.]+ lei)/)[1] + '.';
    var where = LAY === 'L' ? { a: 'pe partea lungă', b: 'pe partea scurtă', c: 'adâncime' } : { a: FOT ? 'lățime' : 'lungime', b: 'pe partea scurtă', c: 'adâncime' };
    ['a', 'b', 'c'].forEach(function (k) {
      var m = M[k]; if (!m) return;
      var runs = [];
      m.vals.forEach(function (x) {
        if (x.hidden || !x.avail || x.price >= 0) return;
        var l = runs[runs.length - 1];
        if (l && l.p === x.price && x.v - l.b <= (step(k) || 5)) l.b = x.v; else runs.push({ a: x.v, b: x.v, p: x.price });
      });
      runs.forEach(function (r) { t += ' La ' + (r.a === r.b ? r.a : r.a + '–' + r.b) + ' cm ' + where[k] + ' prețul scade cu ' + lei(-r.p) + '.'; });
    });
    ROWS.forEach(function (r) { if (!M[r.key] || ['a', 'b', 'c'].indexOf(r.role) >= 0) return; r.vals.forEach(function (x) { if (!x.hidden && x.avail && x.price < 0) t += ' La „' + esc(x.label) + '” prețul scade cu ' + lei(-x.price) + '.'; }); });
    return t + (HAS3D ? ' Prețul exact îl vezi pe loc, în 3D sau aici, pe pagină.</p>' : ' Prețul exact îl vezi pe loc, când alegi.</p>');
  }
  var SHEETS = {
    pret: ['Prețul „de la”', pretText],
    platalivrare: ['Plată și livrare', function () { return clone(['e-f-plata', 'e-f-transport', 'e-f-premium']); }],
    retur: ['Retur', function () { return clone(['e-f-retur', 'e-f-garantie']); }],
    colt: ['Pe ce parte e colțul?', function () {
      return '<p style="margin-bottom:12px">Stai în fața colțarului și te uiți la el. Vezi unde cade partea scurtă.</p><div class="orient">' +
        '<figure>' + orientFig(false) + '<figcaption>Partea scurtă e în <b>stânga</b> ta: colț pe stânga' + (D.cornerPhoto === 'stânga' ? ', ca în poze' : '') + '.</figcaption><button class="btn btn-outline" type="button" data-pick="corner" data-v="stânga" data-close>Aleg colț pe stânga</button></figure>' +
        '<figure>' + orientFig(true) + '<figcaption>Partea scurtă e în <b>dreapta</b> ta: colț pe dreapta' + (D.cornerPhoto === 'dreapta' ? ', ca în poze' : '') + '.</figcaption><button class="btn btn-outline" type="button" data-pick="corner" data-v="dreapta" data-close>Aleg colț pe dreapta</button></figure></div>';
    }],
    toate: ['Toate cele ' + '{n}' + ' de culori', function () {
      if (!FAB.length) return '<p>Se încarcă stofele…</p>';
      return '<p style="margin:0">Apasă pe o culoare ca s-o alegi.' + (fabPaid() ? ' Diferența de preț e scrisă la fiecare grupă.' : ' Toate sunt incluse în preț.') + '</p>' + fabAll('pick') +
        '<button class="btn btn-outline" type="button" data-sheet="mostre" style="margin-top:20px"><svg class="i"><use href="#e-i-swatch"/></svg>Cere mostre gratuite</button>' +
        (D.cfg ? '<div class="links c"><a class="lnk" href="' + esc(D.cfg) + '" data-3d="stofe_toate" data-smx-from="e-stofe-toate"><svg class="i"><use href="#e-i-cube"/></svg>Vezi-le pe model, în 3D ›</a></div>' : '');
    }],
    mostre: ['Mostre gratuite acasă', function () {
      if (!FAB.length) return '<p>Se încarcă stofele…</p>';
      var n = SAMPLES.length;
      return '<p style="margin:0">Bifează până la 10 culori și ți le trimitem gratuit, prin curier.</p>' + fabAll('sample') +
        '<div class="sfoot"><p id="e-sCount">' + (n ? (n === 1 ? '1 mostră: ' : n + ' mostre: ') + esc(SAMPLES.join(', ')) : 'Nicio culoare bifată încă.') + '</p>' +
        (n ? '<a class="btn btn-primary" href="' + esc(waLink('Bună ziua! Aș vrea mostre gratuite pentru ' + (D.title || SHORT) + ': ' + SAMPLES.join(', ') + '.')) + '" target="_blank" rel="noopener"><svg class="i"><use href="#e-i-wa"/></svg>' + (n === 1 ? 'Cere mostra pe WhatsApp' : 'Cere cele ' + n + ' mostre pe WhatsApp') + '</a>'
          : '<span class="btn" aria-disabled="true">Bifează culorile dorite</span>') + '</div>';
    }],
    stofa: [null, function (n) {
      var f = FABN[n];
      if (!f) return '<p>Stofa ' + esc(n) + '. Detaliile se încarcă…</p>';
      var has = SAMPLES.indexOf(n) >= 0, tg = tagsOf(f.fam), big = swatchOf(f.id, 600);
      return '<p class="famline">' + esc(f.fam) + ' · ' + (f.price ? (f.price > 0 ? 'Premium' : 'Standard') + ' · <b>' + sg(f.price) + '</b>' : 'Standard · <b>inclusă în preț</b>') + '</p>' +
        (big ? '<img class="tex" src="' + esc(big) + '" alt="Stofa ' + esc(n) + ', de aproape" decoding="async" onerror="this.remove()">' : '') +
        '<dl class="kv"><div><dt>Familia</dt><dd>' + esc(f.fam) + '</dd></div><div><dt>Grupa de preț</dt><dd>' + (f.price ? (f.price > 0 ? 'Premium' : 'Standard') + ' · ' + sg(f.price) : 'Standard · inclusă') + '</dd></div>' +
        (tg.indexOf('anti-pată') >= 0 ? '<div><dt>Tratament anti-pată</dt><dd>da</dd></div>' : '') + (tg.indexOf('catifelat') >= 0 ? '<div><dt>La atingere</dt><dd>catifelată</dd></div>' : '') + '</dl>' +
        '<p class="cwarn">Pe ecran, culoarea arată altfel decât în casa ta, la lumina de zi și seara. Cere mostra gratuită înainte să comanzi.</p>' +
        '<button class="btn btn-primary" type="button" data-pick="fabric" data-v="' + esc(n) + '" data-close>' + (S.fabric === n ? 'Stofa ta' : 'Alege stofa asta') + '</button>' +
        '<button class="btn btn-outline" type="button" data-sample="' + esc(n) + '">' + (has ? '<svg class="i"><use href="#e-i-check"/></svg>Adăugată la mostre' : SAMPLES.length >= 10 ? 'Ai ales deja 10 mostre' : '<svg class="i"><use href="#e-i-swatch"/></svg>Vreau mostră gratuită') + '</button>' +
        (SAMPLES.length && window.SmxMostre ? '<button class="btn btn-outline" type="button" data-sheet="mostre">' + (SAMPLES.length === 1 ? 'Cere mostra gratuită' : 'Cere cele ' + SAMPLES.length + ' mostre gratuite') + ' ›</button>' : '') +
        '<div class="links c"><a class="lnk wa" href="' + esc(waLink('Bună ziua! Aș vrea fișa tehnică a stofei ' + n + ' (compoziție, Martindale, curățare).')) + '" target="_blank" rel="noopener"><svg class="i"><use href="#e-i-wa"/></svg>Cere fișa tehnică pe WhatsApp ›</a></div>';
    }]
  };
  var curSheet = null, curArg = null;
  function renderSheet() { var d = SHEETS[curSheet]; $('#e-sheetT').textContent = d[0] ? d[0].replace('{n}', fabCount() || '') : curArg; $('#e-sheetB').innerHTML = d[1](curArg); }
  function openSheet(k, arg) {
    /* Mostrele: pop-up-ul unic al site-ului (snippets/smx-mostre.liquid), cu stofele bifate aici deja bifate. Fără el, foaia veche. */
    if (k === 'mostre' && window.SmxMostre) { if (curSheet) closeAll(); window.SmxMostre.open(); return; }
    if (!SHEETS[k]) return; curSheet = k; curArg = arg; renderSheet(); overlayOpen = true; setBar(); $('#e-scrim').classList.add('on'); var sh = $('#e-sheet'); sh.scrollTop = 0; requestAnimationFrame(function () { sh.classList.add('on'); }); }
  /* O foaie deschisă peste vizualizator se închide singură; vizualizatorul rămâne. */
  function closeAll(keepOverlay, all) {
    if (!all && !keepOverlay && curSheet && $('#e-viewer').classList.contains('on')) { $('#e-sheet').classList.remove('on'); $('#e-scrim').classList.remove('on'); curSheet = null; return; }
    $('#e-sheet').classList.remove('on'); $('#e-scrim').classList.remove('on'); $('#e-loading').classList.remove('on'); clearTimeout(slowT); curSheet = null; closeViewer();
    if (!keepOverlay) { overlayOpen = false; setBar(); }
  }
  /* Pop-up-ul de mostre ia stofele de aici și ne spune când omul debifează una acolo. */
  window.smxMostreStofe = function () {
    return SAMPLES.map(function (n) { var f = FABN[n]; return { name: n, img: f ? swatchOf(f.id, 300) : '' }; });
  };
  document.addEventListener('smx-mostre:stofe', function (e) {
    var l = e.detail && Array.isArray(e.detail.stofe) ? e.detail.stofe : null; if (!l) return;
    SAMPLES.length = 0; l.slice(0, 10).forEach(function (n) { SAMPLES.push(n); }); samplesUI();
  });
  function samplesUI() {
    var n = SAMPLES.length;
    $('#e-fMostre span').textContent = n ? ('Mostre (' + n + ')') : 'Mostre gratuite';
    $('#e-bandMostre span').textContent = n === 1 ? 'Cere mostra gratuită' : n ? ('Cere cele ' + n + ' mostre gratuite') : 'Cere mostre gratuite';
    var m = $('#e-mine'); m.hidden = !n; if (n) m.innerHTML = '<b>Mostrele tale:</b> ' + esc(SAMPLES.join(', ')) + '.';
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('.smx-e')) return;
    var s = e.target.closest('[data-sheet]'); if (s) { e.preventDefault(); if (!s.closest('#e-sheet')) sheetFromList = !!s.closest('#e-alege-din-lista'); openSheet(s.dataset.sheet); return; }
    var fi = e.target.closest('[data-fabinfo]'); if (fi) { e.preventDefault(); e.stopPropagation(); if (!fi.closest('#e-sheet')) sheetFromList = !!fi.closest('#e-alege-din-lista'); openSheet('stofa', fi.dataset.fabinfo); return; }
    var sm = e.target.closest('[data-sample]'); if (sm) {
      var n = sm.dataset.sample, i = SAMPLES.indexOf(n);
      if (i < 0 && SAMPLES.length >= 10) { var c = $('#e-sCount'); if (c) c.textContent = 'Poți cere cel mult 10 mostre. Scoate una ca să adaugi alta.'; return; }
      if (i >= 0) SAMPLES.splice(i, 1); else SAMPLES.push(n);
      samplesUI(); var sh = $('#e-sheet'), st = sh.scrollTop; renderSheet(); sh.scrollTop = st; return;
    }
    var tl0 = e.target.closest('[data-e-tolist]'); if (tl0) { toList(); return; }
    if (e.target.closest('[data-close]') || e.target.id === 'e-scrim') {
      var tl = e.target.closest('[data-tolist]');
      if (tl && $('#e-loading').classList.contains('on')) { try { window.stop(); } catch (_) {} }
      if (e.target.closest('.back3d')) { try { window.stop(); } catch (_) {} }
      closeAll(false, !!tl); if (tl) toList();
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  $('#e-toUsa').addEventListener('click', function () { var f = $('#e-faq-usa'); if (f) f.open = true; });

  /* Butonul din primul ecran duce la pasul 1 (sau la primul pas neterminat, dacă omul a ales deja ceva). */
  function toList() {
    if (D.noApo) return;
    S.started = true;
    var s = doneCount() ? firstOpen() : STEPS[0];
    if (s) { curStep = s.id; visited[s.id] = true; }
    update();
    setTimeout(function () { var sec = $('#e-alege-din-lista'); scrollToY(sec.getBoundingClientRect().top + window.pageYOffset - 8); }, 30);
  }
  if ($('#e-toList')) $('#e-toList').addEventListener('click', toList);

  /* Linkurile de WhatsApp: altă mărime, altă întrebare */
  $$('[data-e-wa="other"]').forEach(function (a) { a.href = waLink('Bună ziua! Aș vrea o mărime care nu e pe site: … cm.\nProdus: ' + (D.title || SHORT) + '\n' + (D.url || '')); });
  $$('[data-e-wa="faq"]').forEach(function (a) { a.href = waLink('Bună ziua! Am o întrebare.\nProdus: ' + (D.title || SHORT) + '\n' + (D.url || '')); });

  /* Data estimată de livrare: azi + 3–6 săptămâni („11 nov.–2 dec.”) */
  (function () {
    var L = ['ian.', 'feb.', 'mar.', 'apr.', 'mai', 'iun.', 'iul.', 'aug.', 'sept.', 'oct.', 'nov.', 'dec.'], t = new Date(), w = D.eta || [3, 6];
    var f = function (d) { var x = new Date(t.getFullYear(), t.getMonth(), t.getDate() + d); return x.getDate() + ' ' + L[x.getMonth()]; };
    var a = (+w[0] || 3) * 7, b = (+w[1] || 6) * 7;
    var ed = $('#e-etaDates'), eh = $('#e-etaHero');
    if (ed) ed.textContent = 'Dacă comanzi azi: estimat între ' + f(a) + ' și ' + f(b);
    if (eh) eh.textContent = f(a) + '–' + f(b);
  })();


  /* ---------- Textele care depind de ce rânduri are produsul ---------- */
  function hasSize() { return !!(M.a || M.b || M.c || M.bed); }
  function heroTexts() {
    var n = fabCount(), st = sizeStep(), cul = n ? culori(n) : '';
    var pr = $('#e-promise');
    if (pr) {
      var t = '';
      if (LAY === 'L') t = 'Alegi dimensiunea ' + (step('a') || step('b') ? 'din ' + st + ' în ' + st + ' cm' : 'în cm');
      else if (LAY === 'rect') t = 'Alegi dimensiunea ' + (step('a') ? 'din ' + step('a') + ' în ' + step('a') + ' cm' : 'în cm');
      else if (LAY === 'bed') t = 'Alegi mărimea patului';
      else if (M.c) t = 'Alegi adâncimea în cm';
      if (t) pr.textContent = t + (cul ? ' · ' + cul : '');
      else if (cul) pr.textContent = 'Alegi stofa din ' + cul;
      else pr.hidden = true;
    }
    var tl = $('#e-toList'), tls = tl && $('span', tl);
    var cmSizes = !!(M.a || M.b || M.c);
    /* Butoanele spre pași: „Configurează din listă, în 3 pași” (cu 3D), „Configurează-ți colțarul în 3 pași” (fără 3D), „Alege stofa” (doar stofă). */
    if (!D.noApo && STEPS.length) {
      if (tls) tls.textContent = goTxt(HAS3D);
      if (!HAS3D) {
        var bt = goTxt(false), bg = $('#e-barGo');
        if (bg && bg.textContent !== bt) { bg.textContent = bt; bg.__fit = false; }
        if (bg) bg.__alts = STEPS.length > 1 ? ['Configurează în ' + STEPS.length + ' pași', 'Configurează'] : [];
        var vb = $('#e-vbotBtn'); if (vb) vb.textContent = bt;
        var vt = $('#e-vbotTxt'); if (vt) vt.innerHTML = '<b>Aici îl vezi într-o singură stofă.</b>' + (hasSize() ? 'Stofa și mărimea le alegi în ' + STEPS.length + ' pași, cu prețul pe loc.' : 'Stofa o alegi din listă, cu prețul pe loc.');
      }
    }
    var dn = $('#e-dnote'); if (dn) dn.textContent = LAY === 'bed' ? 'Mărimea saltelei.' : 'Cu tot cu ' + (NOARMS ? '' : 'cotierele și ') + 'spătarul, din ' + st + ' în ' + st + ' cm.';
    var top = LAY !== 'none';
    planCard.hidden = !top;
    ['#e-topLbl', '#e-bigPlan', '#e-dnote'].forEach(function (s) { var el = $(s); if (el) el.hidden = !top; });
    $('#e-yours').hidden = !top;
    var sep = $('#e-sideSep'); if (sep) sep.hidden = !top;
    var sl = $('#e-showLede'); if (sl && !M.comfort) sl.textContent = 'Te așezi pe el și pipăi stofele.';
    if (apoOk && !D.noApo) {
      /* Pasul 1 din „Cum îl comanzi”: cu 3D sau fără, cu mărimi în cm, cu mărimea patului sau doar stofa. */
      var s1 = $('#e-step1'), others = REQ.some(function (k) { return k !== 'fabric'; });
      if (s1 && !(HAS3D && cmSizes)) s1.textContent = HAS3D ? (hasSize() ? 'În 3D sau în pașii de mai sus. Prețul îl vezi pe loc.' : 'Mărimea o potrivești în 3D. Stofa o poți alege și mai sus. Prețul îl vezi pe loc.')
        : cmSizes ? 'Alegi mai sus mărimea, în centimetri, și stofa. Prețul îl vezi pe loc.'
        : M.bed ? 'Alegi mai sus mărimea patului și stofa. Prețul îl vezi pe loc.'
        : others ? 'Alegi mai sus ce variantă vrei. Prețul îl vezi pe loc.' : 'Alegi stofa mai sus. Prețul îl vezi pe loc.';
      /* Fără mărimi de ales: Specificațiile nu promit mărimi. */
      if (!hasSize()) {
        var eb = $('#e-eyebrow5'); if (eb) eb.hidden = true;
        var t5 = $('#e-t5'); if (t5) t5.textContent = FAB.length ? 'Stofa și detalii' : 'Detalii';
        var stT = $('#e-sameT'); if (stT && stT.firstChild && stT.firstChild.nodeType === 3) stT.firstChild.nodeValue = 'Detalii';
      }
      /* „de la” are sens doar dacă prețul se poate schimba. */
      var paid = FAB.some(function (f) { return f.price; }) || ROWS.some(function (r) { return M[r.key] && r.vals.some(function (x) { return x.price; }); });
      var fl = $('#e-fromLbl'); if (fl) fl.hidden = !paid;
      var bfs = $('#e-bar .bp small'); if (bfs) bfs.hidden = !paid;
    }
    faqFilter();
  }

  /* ---------- Întrebările: fiecare linie apare doar unde i se potrivesc condițiile ---------- */
  function condOk(c) {
    var neg = c.charAt(0) === '!'; if (neg) c = c.slice(1).trim();
    var r;
    if (c === 'profil') r = PROF;
    else if (c === 'confort') r = !!M.comfort;
    else if (c === 'marimi') r = !!(M.a || M.c || M.bed);
    else if (c === 'stofa') r = FAB.length > 0;
    else if (c === 'colt') r = !!M.corner;
    else if (c === 'ext') r = EXT;
    else r = c.split(/\s+/).indexOf(KIND) >= 0;
    return neg ? !r : r;
  }
  function faqFilter() {
    var wt = weightTxt();
    var TOK = { pat: PROF ? '' : (D.bedText || ''), greutate: wt ? 'Cântărește ' + wt.v + (wt.s ? ', ' + wt.s : '') + '.' : '' };
    $$('#e-intrebari details').forEach(function (d) {
      var w = d.getAttribute('data-e-when'), ok = true;
      if (w) ok = w.split(',').every(function (c) { c = c.trim(); return !c || condOk(c); });
      $$('[data-e-tok]', d).forEach(function (sp) { var v = TOK[sp.getAttribute('data-e-tok')]; if (v) sp.textContent = v; else ok = false; });
      d.hidden = !ok;
      if (d.id === 'e-faq-usa') d.removeAttribute('id');
    });
    if (apoOk || D.noApo) {
      var rv = $('#e-reviews');
      if (rv) {
        $$('li[data-e-when]', rv).forEach(function (li) { li.hidden = !li.getAttribute('data-e-when').split(',').every(function (c) { c = c.trim(); return !c || condOk(c); }); });
        rv.hidden = !$$('li', rv).some(function (li) { return !li.hidden; });
      }
    }
    var usa = $$('#e-intrebari details[data-e-usa]').filter(function (d) { return !d.hidden; })[0];
    if (usa) usa.id = 'e-faq-usa';
    $('#e-toUsaBox').hidden = !usa;
    var drawing = $('#e-specificatii .drawing');
    if (drawing) drawing.hidden = !(LAY !== 'none' || !$('#e-side').hidden || usa);
  }

  /* ---------- Pornirea: întâi conținutul din tabel și pagina cu prețul din Liquid, apoi APO ---------- */
  applyContent();
  figs();
  faqFilter();
  buildSteps();
  if (STEPS.length) { curStep = STEPS[0].id; visited[curStep] = true; }
  if (!D.noApo) { fSel(); update(); } else heroTexts();

  var rebuilding = false, lastSig = '';
  function sigOf() {
    var parts = [];
    try {
      (ap.getState().options || []).forEach(function (o) {
        if (o.hidden) return; parts.push(o.id);
        getVals(o).forEach(function (v) { if (v.hiddenByRule) parts.push(v.id); });
      });
    } catch (err) {}
    return parts.join(',');
  }
  /* O regulă APO a comutat (altă opțiune vizibilă, alte valori ascunse): refacem rândurile și păstrăm alegerile care mai există. */
  function rebuild() {
    rebuilding = true;
    var gone = [];
    try {
      syncFromApo();
      var prev = {};
      ROWS.forEach(function (r) {
        if (r.role === 'fabric' || r.text || S[r.key] == null || !M[r.key]) return;
        var x = M[r.key].byV[S[r.key]]; if (x) prev[r.key] = { v: S[r.key], label: x.label, ids: vals(x.ids) };
      });
      buildModel(); renderRows();
      Object.keys(prev).forEach(function (k) {
        var p = prev[k], r = M[k], x = r && r.byV[p.v], sel = selNow();
        if (x && !x.hidden) { if (!vals(x.ids).every(function (id) { return sel.indexOf(id) >= 0; })) apoPick(k, p.v); }
        else { ap.setValues(sel.filter(function (id) { return p.ids.indexOf(id) < 0; })); gone.push(p.label); }
      });
      lastSig = sigOf();
    } catch (err) {}
    rebuilding = false;
    if (gone.length) toast('Am scos alegerea „' + gone.join('”, „') + '”: nu mai e disponibilă la ce ai ales acum.', 5000);
    syncFromApo(); heroTexts(); update();
  }
  function onRecalc() {
    if (!rebuilding) { var sgn = sigOf(); if (sgn !== lastSig) { rebuild(); return; } }
    updateSoon();
  }
  /* Evenimentele APO ('recalculated', 'change') vin în rafală după fiecare alegere: un singur update() pe cadru. */
  var uQ = 0;
  function updateSoon() { if (uQ) return; uQ = requestAnimationFrame(function () { uQ = 0; update(); }); }

  /* Produsul nu are opțiuni APO (de ex. paginile configuratorului): după ~20 s fără APO, pagina trece pe „Preț la cerere” și WhatsApp.
     Dacă APO apare totuși mai târziu, se revine. */
  var noApoJs = false;
  function noApoMode(on) {
    if (on === noApoJs) return;
    noApoJs = on; D.noApo = on;
    root.classList.toggle('e-noapo', on);
    ['#e-alege-din-lista', '#e-stofe', '#e-grpPick', '#e-toList', '#e-promise'].forEach(function (q) { var el = $(q); if (el) el.hidden = on; });
    var fl = $('#e-fromLbl'); if (fl) fl.hidden = on;
    var wa = $('#e-askPriceJs');
    if (on) {
      $('#e-heroPrice').textContent = 'Preț la cerere';
      if (!wa) {
        wa = document.createElement('a'); wa.id = 'e-askPriceJs'; wa.className = 'cta-2 wa'; wa.target = '_blank'; wa.rel = 'noopener';
        wa.href = waLink('Bună ziua! Aș vrea prețul pentru ' + (D.title || SHORT) + '. ' + (D.url || ''));
        wa.innerHTML = '<svg class="i"><use href="#e-i-wa"/></svg>Cere prețul pe WhatsApp';
        var risk = $('.smx-e .buy .risk'); risk.parentNode.insertBefore(wa, risk);
      }
      var s1t = $('#e-step1t'), s1 = $('#e-step1');
      if (s1t) { s1t.dataset.orig = s1t.textContent; s1t.textContent = 'Ceri oferta'; }
      if (s1) { s1.dataset.orig = s1.textContent; s1.textContent = 'Ne scrii pe WhatsApp ce mărime și ce stofă vrei, iar noi îți facem oferta.'; }
    } else {
      if (wa) wa.remove();
      var t1 = $('#e-step1t'), p1 = $('#e-step1');
      if (t1 && t1.dataset.orig) t1.textContent = t1.dataset.orig;
      if (p1 && p1.dataset.orig) p1.textContent = p1.dataset.orig;
    }
    setBar();
  }

  function onApoReady(inst) {
    if (apoOk || !inst) return;
    if (noApoJs) noApoMode(false);
    ap = inst;
    try { buildModel(); } catch (err) { return; }
    apoOk = true;
    root.classList.add('e-apo-ok');
    lastSig = sigOf();
    renderRows();
    DEF = selNow().slice();
    var restored = restoreSel();
    syncFromApo();
    /* Pasul deschis: înapoi din coș cu totul ales = pașii strânși și „Configurația ta”; altfel primul pas neterminat. */
    if (restored || !curStep) { var fo = complete() ? null : (doneCount() ? firstOpen() : STEPS[0]); curStep = fo ? fo.id : null; }
    if (curStep) visited[curStep] = true;
    lastTot = total();
    if (doneCount()) S.started = true;
    heroTexts();
    update();
    ap.on('recalculated', onRecalc);
    ap.on('change', function () { syncFromApo(); updateSoon(); });
    if (pend) {
      var pp = pend, pr = M[pp.k]; pend = null; $$('.smx-e [data-pick].pend').forEach(function (b) { b.classList.remove('pend'); });
      /* Alegerea făcută înainte de APO se aplică doar dacă produsul are rândul și valoarea; altfel se renunță la ea, fără mesaj. */
      var exists = pp.k === 'fabric' ? !!FABN[pp.v] : !!(pr && pr.byV[(pr.role === 'a' || pr.role === 'b' || pr.role === 'c') ? +pp.v : pp.v]);
      if (exists) doPick(pp.k, pp.v, true);
    }
  }
  /* Înapoi din coș: punem la loc alegerile salvate înainte de „Adaugă în coș” (doar id-urile care mai există în APO). */
  function restoreSel() {
    var nav = null;
    try { nav = performance.getEntriesByType('navigation')[0]; } catch (_) {}
    if (!nav || nav.type !== 'back_forward') return;
    var saved = null;
    try { saved = JSON.parse(sessionStorage.getItem(SELKEY) || 'null'); } catch (_) {}
    if (!saved || !saved.ids || !saved.ids.length || Date.now() - saved.t > 3 * 3600 * 1000) return;
    try {
      var valid = [];
      ROWS.forEach(function (r) { (r.vals || []).forEach(function (x) { valid = valid.concat(vals(x.ids)); }); });
      FAB.forEach(function (f) { valid.push(f.id); });
      var ids = saved.ids.filter(function (id) { return valid.indexOf(id) >= 0; });
      if (!ids.length) return;
      /* APO poate fi pornit deja cu valorile lui implicite (de ex. lungimea 210): selecția salvată le înlocuiește. */
      var cur = selNow();
      if (cur.length !== ids.length || !ids.every(function (id) { return cur.indexOf(id) >= 0; })) ap.setValues(ids);
      DEF = [];
      return true;
    } catch (_) {}
    return false;
  }
  function findInstance() {
    try {
      var list = window.mwApo.instances() || [];
      for (var i = 0; i < list.length; i++) { var st = list[i].getState(); if (st && st.options && st.options.length) return list[i]; }
    } catch (err) {}
    return null;
  }
  var tries = 0;
  /* Produs fără opțiuni APO: APO a răspuns la cererea produsului (de ex. 204, fără opțiuni) de peste 3 s și tot nu are instanță,
     sau scriptul APO lipsește cu totul după ~20 s. Un APO doar lent (cererea încă în curs) nu trece pagina pe „Preț la cerere”. */
  function apoEmpty() {
    if (apoOk || (apoBox && apoBox.querySelector('.mw-option'))) return false;
    if (!window.mwApo) return tries >= 152;
    var es = [];
    try { es = performance.getEntriesByType('resource').filter(function (r) { return /apo-admin\.mageworx\.com\/front\/product\//.test(r.name); }); } catch (err) { return false; }
    if (!es.length) return false;
    return performance.now() - es[es.length - 1].responseEnd > 3000 && !findInstance();
  }
  if (!D.noApo) (function waitApo() {
    if (window.mwApo && typeof window.mwApo.instances === 'function') {
      var hit = findInstance();
      if (hit) { onApoReady(hit); return; }
      if (typeof window.mwApo.ready === 'function' && !waitApo.hooked) {
        waitApo.hooked = true;
        try { window.mwApo.ready(function () { var h = findInstance(); if (h) onApoReady(h); }); } catch (err) {}
      }
    }
    if (apoOk) return;
    ++tries;
    if (!noApoJs && apoEmpty()) noApoMode(true);
    if (tries === 150) {
      $$('.e-wait').forEach(function (p) { p.innerHTML = 'Opțiunile se încarcă greu. Mai așteaptă puțin, reîncarcă pagina sau scrie-ne pe WhatsApp.'; });
      $('#e-missing').textContent = 'Opțiunile se încarcă greu. Mai așteaptă puțin, reîncarcă pagina sau scrie-ne pe WhatsApp.';
    }
    /* După ~18 s nu ne oprim: sondăm rar, ca pagina să-și revină dacă APO vine târziu. */
    setTimeout(waitApo, tries < 150 ? 120 : 1000);
  })();
})();
